export default {
  salesCenter: {
  caseLabel: 'Case',
  viewCount: 'Views',
  viewRule: 'View Rules',
  collectCount: 'Favorites',
  outboundCaller: 'Outbound caller',
  outboundRecordsQueryTime: 'Query time: ',
  outboundRecordsCallDuration: 'Call duration: ',
  outboundRecordsPhoneStatus: 'Number status',
  callTypeOutbound: 'Outbound',
  callType: 'Call type',
  activityId: 'Activity ID',
  aboutToRecycle: 'About to Recycle',
  above6000: 'Above 6000',
  accountActivateDate: 'Account Activate Date',
  accountActivateDateLabel: 'Account Activate Date:',
  dispatchDate: 'Dispatch Date',
  accountActivateTime: 'Account Activate Time',
  accountLabel: 'Account',
  outCallAgentLoginMode: 'Agent account login',
  accountPhoneRebind: 'Account Phone Rebind',
  accountStatus: 'Account Status',
  accountStatusLabel: 'Account Status:',
  backActivityList: 'Back to Activity List',
  accountValidPeriod: 'Account Valid Period',
  activate: 'Activated',
  activated: 'Activated',
  activity: 'Activity',
  activityCreateFail: 'Activity creation failed',
  activityCreateSuccess: 'Activity created successfully',
  createActivityButton: 'Create Activity',
  activityStatusNotStarted: 'Not Started',
  activityStatusInProgress: 'In Progress',
  activityStatusEnded: 'Ended',
  copyLinkLabel: 'Copy Link',
  inviteRewardPeopleSuffix: ' people, reward',
  inStoreRewardPeopleSuffix: ' people, reward',
  activityDeleteFail: 'Activity delete failed',
  activityDeleteSuccess: 'Activity deleted successfully',
  activityEditFail: 'Activity edit failed',
  activityEditSuccess: 'Activity edited successfully',
  activityName: 'Activity Name',
  activityPauseFail: 'Activity pause failed',
  activityPauseSuccess: 'Activity paused successfully',
  activityPublishFail: 'Activity publish failed',
  activityPublishSuccess: 'Activity published successfully',
  activityStartFail: 'Activity start failed',
  activityStartSuccess: 'Activity started successfully',
  activityTemplateTitle: 'Marketing Activity Template',
  /** Activity gallery — add template button (auto_530 is grade “junior high”, not this label) */
  activityGalleryAddNewTemplate: 'Add activity template',
  actualReturnAmount: 'Total Returned Amount',
  actualVisitTime: 'Actual Visit Time:',
  actualVisitTip: 'Time customer actually visited store',
  adapAccountLabel: 'Adaptive Account:',
  adaptiveAccountLabel: 'Adaptive Account: ',
  pleaseSelectAdaptiveAccount: 'Please select adaptive account',
  add: 'Add',
  addCounter: '+ Add Counter',
  addExamInfo: 'Add Exam Info',
  addFollowRecord: 'Add Follow Record',
  addLead: 'Add Lead',
  addReport: 'Add Report',
  addScoreFail: 'Failed to add score',
  addSingleImage: 'Add Single Image',
  addSubTag: 'Add Sub Tag',
  addSuccess: 'Added successfully',
  addTagType: 'Add Tag Type',
  addTemplate: 'Add',
  addUserProfile: 'Add User Profile',
  addVideo: 'Add Video',
  addressTooShort: 'Address too brief, please fill in detail',
  adjustTable: 'Adjust Table Display',
  admissionCannotExceedFinalScore: 'Admission score cannot exceed final score',
  admissionScoreCannotExceedSubjectTotal: 'Admission score cannot exceed subject total',
  admissionScoreCannotExceedTotal: 'Admission score cannot exceed total score',
  admissionScoreFormatError: 'Admission score format incorrect',
  admissionScoreLabel: 'Admission score',
  admissionStageGrade: 'Admission Stage/Grade',
  admissionStageCannotExceedCurrent: 'Admission stage cannot exceed current stage',
  agent: 'Agent',
  agentId: 'Agent ID',
  agentLabel: 'Agent',
  agentName: 'Agent Name',
  agreeTransfer: 'Agree Transfer',
  all: 'All',
  allLeads: 'All Leads',
  allocated: 'Assigned',
  allocation: 'Assign',
  already: 'Subscribed',
  alreadyExpired: 'has',
  analystLabel: 'Analyst:',
  analystPersonLabel: 'Analyst',
  applySuccess: 'Application successful',
  applyTimeLabel: 'Apply Time:',
  applyTransfer: 'Apply Transfer',
  appointmentTimeAfterNow: 'Selected time must be after current time',
  approvalFailed: 'Approval failed',
  approvalSuccess: 'Approval successful',
  assignAnalyst: 'Assign Analyst',
  assignSuccess: 'Assigned successfully',
  assignTo: 'Assign to:',
  audit: 'Auditor',
  auditBy: 'Confirmed By',
  auditRejectReason: 'Audit Rejection Reason',
  auditRejectTip: 'Your application for "{name}" was not approved. Reason: "{remark}". Please revise and resubmit.',
  auditRemark: 'Confirm Remark',
  auditStatus: 'Audit Status',
  auditTime: 'Confirm Time',
  availablePrototypeCount: 'Available Prototype Count',
  back: 'Back',
  basicInfo: 'Basic Info',
  batchAllocation: 'Batch Assign',
  batchAllocationFailed: 'Batch assign failed',
  batchAllocationSuccess: 'Batch assign successful',
  batchAllocationTitle: 'Batch Assign',
  batchAssignAnalyst: 'Batch Assign Analyst',
  batchAssignAnalystTitle: 'Batch Assign Analyst',
  batchAssignFollowPerson: 'Batch Assign Follow Person',
  batchAssignServicePerson: 'Batch Assign Service Person',
  batchAllocateFollower: 'Batch Allocate Follower',
  batchClaim: 'Batch Claim',
  batchCollection: 'Batch Claim',
  batchCollectionFailed: 'Batch claim failed',
  batchCollectionSuccess: 'Batch claim successful',
  batchExport: 'Batch Export',
  batchImport: 'Batch Import',
  batchImportBusy: 'Batch import is busy, please try again in 10 minutes',
  batchImportLead: 'Batch Import Leads',
  batchOperation: 'Batch Operation:',
  batchRecall: 'Batch Recall',
  batchRecover: 'Batch Recall',
  batchRecoverSuccess: 'Batch recall successful',
  batchRelease: 'Batch Release',
  batchReleaseSuccess: 'Batch release successful',
  batchRestore: 'Batch Restore',
  batchRestoreSuccess: 'Batch restore successful',
  batchSaveTip: ', max 5 images per save',
  batchUploadImages: 'Batch Upload Images',
  batchUploadTip: 'Note: Batch upload will auto-number image names (e.g. "Daily Image 01"). You can edit in gallery list.',
  bayear: 'Grade 8',
  below2000: 'Below 2000',
  bestSize: 'Recommended size 1080x1920',
  between2000and4000: '2000~4000',
  between4000and6000: '4000~6000',
  bianji: 'Last Edited By',
  bindFailed: 'Bind failed',
  bindPhoneTip: 'This account has no bound phone. Please bind a phone number first.',
  bindPhoneTitle: 'Bind Phone Number',
  bindSuccess: 'Bind successful',
  birthDate: 'Birth Date:',
  birthDateLabel: 'Birth Date',
  birthDateLabelShort: 'Birth Date: ',
  briefIntroLength50_500: 'Brief intro 50-500 characters',
  businessStatus: 'Business Status',
  buttonPicLabel: 'Button Image:',
  campus: 'Campus',
  cancel: 'Cancel',
  cancelCreateDone: 'Create cancelled',
  cancelDeleteDone: 'Delete cancelled',
  cancelFollow: 'Cancel Follow',
  cancelFollowReasonTip: 'Please fill in reason for cancellation',
  cancelFollowSuccess: 'Cancel follow successful',
  cancelPauseDone: 'Pause cancelled',
  cancelPublish: 'Cancel Publish',
  cancelPublishDone: 'Publish cancelled',
  cancelPublishFailed: 'Failed to cancel publish',
  cancelPublishSuccess: 'Cancel publish successful',
  cancelReason: 'Cancel Reason:',
  cancelReasonLabel: 'Cancel Reason: ',
  cancelReportConfirmText: 'Confirm to cancel report application?<br>Once cancelled, the device cannot be activated across regions!',
  cancelReportConfirmTitle: 'Cancel Report Application',
  cancelReportFail: 'Cancel report failed',
  cancelReportSuccess: 'Cancel report success',
  cancelStartDone: 'Start cancelled',
  cancelSuccess: 'Cancelled successfully',
  cannotChangeSubmitted: 'Cannot change. Information has been submitted for review',
  cannotWithdrawApproved: 'Cannot withdraw. Student registration has been approved',
  caozuo: 'Operation',
  caseTitleLength: 'Case title: 5~20 characters',
  catalogCategory: 'Catalog Category',
  catalogNameMax10: 'Length must not exceed 10',
  categoryName: 'Category Name',
  categoryNameRequired: 'Category name is required',
  changeSuccess: 'Change successful!',
  channel: 'Channel',
  channelSource: 'Channel Source',
  channelSourceStats: 'Channel Source Statistics',
  chargePhone: 'Manager Phone',
  chuandan: 'Micro Flyer',
  chuangjian: 'Creator',
  ci: 'Invite Again',
  cihour: 'First Vote Time',
  citeExistingLead: 'Cite existing lead:',
  citeLeadTip: 'You can bind and quickly complete profile by citing leads created in "Prospects"',
  citeLeadTipHtml: 'You can bind and quickly complete profile by citing leads created in <span style="font-weight: 600;">"Prospects"</span>',
  claimStudent: 'Claim Student',
  claimStudentValidityTip: 'Claimed students are valid for 7 days. Please follow up promptly',
  claimSuccess: 'Claim successful',
  clickToViewVideo: 'Click to view video',
  clickUpload: 'Click to upload',
  closeFailed: 'Close failed',
  closeSuccess: 'Closed successfully',
  closeTitle: 'Close',
  code: 'Code',
  collapse: 'Collapse',
  compliant: 'Compliant',
  confirm: 'Confirm',
  confirmAcceptTransfer: 'Confirm to accept new student transfer?',
  confirmCancelPublishMaterial: 'Cancel publishing this material?',
  confirmDeleteImage: 'Confirm to delete this image?',
  confirmDeleteMarker: 'Confirm to delete this marker?',
  confirmDeleteMaterial: 'Delete this material? It cannot be recovered.',
  confirmDeleteTagType: 'Confirm to delete tag type 【{name}】?',
  confirmDeleteTemplate: 'Confirm to delete template?',
  confirmOffShelfImage: 'Confirm to take this image off shelf?',
  confirmOffShelfTemplate: 'Confirm to take template off shelf?',
  confirmPublishImage: 'Confirm to publish this image?',
  confirmPublishMaterial: 'Publish this material?',
  confirmPublishTemplate: 'Confirm to publish template?',
  confirmReceiveCustomers: 'Confirm to claim {n} customer(s)?',
  confirmRejectTransfer: 'Confirm to reject new student transfer?',
  confirmRestoreCluesTip: 'Confirm to restore these {n} leads?',
  confirmRevokeApply: 'Confirm to revoke application?',
  confirmSubmitAudit: 'Confirm to submit for audit?',
  confirmUnmarkPrototype: 'Confirm to unmark prototype?',
  confirmUpdate: 'Confirm Update',
  confirmUpdateTip: 'Confirm to update?',
  considerAgain: 'Think again',
  consultation: 'Consultation',
  contactInfo: 'Contact Info',
  converted: 'Converted',
  coordsParentAgentId: 'Coords Parent Agent ID',
  coordsPassed: 'Coords Passed',
  coordsProvinceCity: 'Coords Province/City',
  copy: 'Copy',
  counterAddress: 'Counter Address',
  counterAgentId: 'Agent ID',
  counterAgentLabel: 'Agent',
  counterAgentName: 'Agent Name',
  counterChargePerson: 'Counter Manager',
  counterCloseConfirm: 'Counter closure cannot be undone.<br />Confirm to close?',
  counterInfoExport: 'Counter Info Export',
  counterNo: 'Counter No.',
  counterType: 'Counter Type',
  course: 'Course',
  courseName: 'Course Name',
  textbookVersion: 'Textbook Version',
  orderRecords: 'Order Records',
  invitationRecords: 'Invitation Records',
  learningReport: 'Learning Report',
  sailingTrialClass: 'Sailing Trial Class',
  createBy: 'Created By',
  createFail: 'Create failed',
  createMaterial: 'Create Material',
  createNow: 'Create Now',
  createSuccess: 'Created successfully',
  createTime: 'Create Time',
  crossAreaTypeFail: 'Failed to get cross region type and report agents',
  crossRegionNotReported: 'Cross Region Not Reported',
  crossRegionPendingReview: 'Cross Region Pending Review',
  crossRegionType: 'Cross Region Type',
  crossSubjectDeviceTip: 'This student',
  crossSubjectExhaustTip: 'When quota is exhausted, cross-entity transfers require provincial approval.',
  crossSubjectLimitExceeded: 'Cross-entity device students exceed the maximum limit. Transfer not allowed.',
  crossSubjectPendingAudit: 'Application submitted. Please wait for approval.',
  crossSubjectQuotaTip: 'Transferring this student for supervision will consume one cross-entity quota.',
  crossSubjectRemainLimit: 'Your remaining exempt-audit cross-entity quota this month: ',
  crossSubjectTitle: 'Cross-Entity Supervision',
  crossSubjectUnknown: 'Cross-entity check result unknown. Please try again later.',
  currentAuthArea: 'Current Auth Area',
  currentServiceCenterId: 'Current Service Center ID:',
  currentServiceCenterName: 'Current Service Center Name:',
  customNameRequired: 'Name is required',
  customTable: 'Custom Table',
  customer: 'Please select customer channel',
  customerChannel: 'Customer Channel',
  leadsPickTimeRangeLabel: 'Pickup time range',
  leadsPickTimeColumn: 'Pickup time',
  customerName: 'Customer Name',
  customerNameLabel: 'Customer Name:',
  customerNameLabelShort: 'Customer Name',
  customerNameOrPhone: 'Customer name/phone',
  customerNamePhone: 'Customer Name/Phone',
  customerPhone: 'Customer Phone',
  customerPhoneLabel: 'Customer Phone',
  dachaxun: 'Promoter Query:',
  dailyImage: 'Daily Image',
  danhao: 'Express No.',
  dao: 'Visit Store',
  dataMigration: 'Data Migration',
  dataValidate: 'Data Validate',
  dataValidateComplete: 'Data validation complete, {total} student leads',
  dataValidateError: '{error} errors, please modify and try again',
  dataValidateFail: 'Data validation failed',
  logisticsDetailTitle: 'Logistics Detail',
  logisticsCompanyName: 'Company Name',
  pleaseSelectCompany: 'Please select company',
  latestTag: 'Latest',
  machineRemarkTitle: 'Machine Remark',
  remarkLabelShort: 'Remark',
  remarkPlaceholder: 'Please enter content',
  accountRebindTitle: 'Phone Rebind',
  learningMachineAccountNo: 'Learning Machine Account No.',
  learningMachineAccount: 'Learning Machine Account',
  learningMachineAccountLabel: 'Learning Machine Account:',
  originalMobileLabel: 'Original Mobile',
  newMobileLabel: 'New Mobile',
  pleaseEnterOriginalMobile: 'Please enter original mobile',
  pleaseEnterNewMobile: 'Please enter new mobile',
  verifyCodeLabel: 'Verification Code',
  pleaseEnterVerifyCode: 'Please enter verification code',
  sendVerifyCode: 'Send Code',
  resendVerifyCode: 'Resend',
  resendAfterSeconds: 'Resend after {time}s',
  dataValidateResult: '{error} errors, {repeat} duplicates, {pass} can be imported',
  day: 'Report Date',
  learningReportDateLabel: 'Report Date',
  dealerId: 'Dealer ID',
  dealerInfo: 'Dealer Info',
  dealerLocation: 'Dealer Location',
  dealerName: 'Dealer Name',
  dealerNoQualification: 'Dealer has no service center qualification. Please register store address first.',
  dealerParentAgentId: 'Dealer Parent Agent ID',
  delete: 'Delete',
  deleteConfirmContent: 'After deletion, campuses cannot use this image. Confirm delete?',
  deleteConfirmDesc: 'Note: Activities that used this image will continue to use it. If the material is risky, please notify principals to pause use.',
  deleteFailed: 'Delete failed',
  deleteImage: 'Delete image',
  deleteMarker: 'Delete',
  deleteSuccess: 'Deleted successfully',
  detailAddress: 'Detail Address',
  details: 'Details',
  detailLabel: 'Details',
  device: 'Device Model',
  deviceSN: 'Device SN',
  differentModelCannotMerge: 'Different models or prices cannot be merged for exchange',
  dili: 'Geography',
  dispatchedPrototypeCount: 'Dispatched Prototype Count',
  displayStatus: 'Display Status',
  downloadErrorFile: 'Download Error File',
  dragFileHereOr: 'Drag file here, or',
  edit: 'Edit',
  editExamInfo: 'Edit Exam Info',
  editFollowRecord: 'Edit Follow Record',
  editImage: 'Edit Image',
  editInfo: 'Edit Info',
  editProfileTitle: 'Edit Profile',
  editSchoolInfo: 'Edit School Info',
  editSuccess: 'Edit successful',
  editTemplate: 'Edit',
  effectTime: 'Effective Time',
  endDate: 'End Date',
  enterExamInfoAtLeastOneYear: '(Enter at least one year of exam info)',
  enterExamInfoTitle: 'Enter exam info',
  entryAccountCustomerNameOrPhone: 'Customer Name/Phone',
  entryAccountExperienceDate: 'Experience Date',
  entryAccountExperienceEndDate: 'Experience End Date',
  entryAccountExperienceStartDate: 'Experience Start Date',
  entryAccountLearningMachine: 'Learning Machine',
  entryAccountOpenPerson: 'Opened By',
  entryAccountOpenTime: 'Open Time',
  entryAccountPleaseEnterSnCode: 'Please enter learning machine SN',
  entryAccountPleaseSelectStatus: 'Please select status',
  entryAccountSearchCustomer: 'Search Customer',
  entryAccountSnCode: 'Learning Machine SN',
  er: 'Grade 2',
  eryear: 'Grade 2',
  examInfoTipFeedback: 'If school not found, contact support to add new school',
  examProvinceCity: 'Province/City',
  examStageName: 'Stage',
  exceed10MLimit: 'Exceeds 10M limit. Upload not allowed',
  exceed20MLimit: 'Exceeds 20M limit. Upload not allowed',
  exceed5MLimit: 'Exceeds 5M limit. Upload not allowed',
  expand: 'Expand',
  experienceAccountLabel: 'Experience Account: ',
  experienceAccountPasswordLabel: 'Experience Account Password:',
  experienceAnalystLabel: 'Experience Analyst:',
  experienceAnalyst: 'Experience Analyst',
  experienceDate: 'Experience Date',
  inviteExperienceDetailAccountLabel: 'Account:',
  inviteExperienceDetailPasswordLabel: 'Password:',
  inviteExperienceDetailDateLabel: 'Experience Date:',
  inviteExperienceDetailCourseLabel: 'Experience Course:',
  inviteExperienceDetailFenyuanLabel: 'Analyst:',
  experienceDateFormat: 'MMM dd, yyyy',
  experienceEndDate: 'Experience End Date',
  experienceInProgress: 'In Progress',
  experienceQuotaExhausted: 'Experience quota exhausted',
  experienceStartDate: 'Experience Start Date',
  experienceStartDateLabel: 'Experience Start Date:',
  experienceSuccess: 'Experience successful',
  expired: 'Expired',
  exportCurrentDetail: 'Export Current Detail',
  exportDetail: 'Export Detail',
  exportSuccess: 'Export successful',
  fail: 'Fail',
  familyMember1: 'Family Member 1:',
  familyMember1Label: 'Family Member 1',
  familyMember1LabelShort: 'Family Member 1: ',
  familyMember2: 'Family Member 2:',
  familyMember2Label: 'Family Member 2',
  familyMember2LabelShort: 'Family Member 2: ',
  contactLabel: 'Contact',
  female: 'Female',
  fen: 'Above 40 points',
  fenlei: 'Classification',
  fenshu: 'Progress Score',
  fenxiaoyuan: 'Distributor',
  pleaseSelectDistributor: 'Please select distributor',
  fenyuan: 'Analyst',
  fileAddFail: 'File add failed',
  fileName: 'File Name',
  fileSizeExceed1MB: 'File size cannot exceed 1MB',
  fileSizeExceed5M: 'File size cannot exceed 5M',
  fillCompleteExamInfo: 'Please fill in complete exam information',
  fillCreateInfo: 'Fill Create Info',
  finalScoreCannotExceedTotal: 'Final score cannot exceed subject total',
  finalScoreGtEnrollment: 'Final score must be greater than enrollment score',
  finalScoreLteTotal: 'Final score cannot exceed subject total score',
  finishTime: 'Finish Time',
  finisher: 'Finisher',
  flyerHeadPic: 'Flyer Header:',
  follow: 'Follow Person',
  followAction: 'Follow Up',
  followContentRequired: 'Follow content is required',
  followDesc: 'Follow Description:',
  followFail: 'Follow failed',
  followInfo: 'Follow Info',
  followLabel: 'Follow Up:',
  followPerson: 'Follow Person:',
  followPersonLabel: 'Follow Person:',
  followPersonLabelShort: 'Follow Person: ',
  followPersonRequired: 'Follow person is required',
  followPersonShort: 'Follow Person',
  followRecord: 'Follow Record',
  followRemindTitle: 'Follow Reminder',
  followStatusColumn: 'Follow Status',
  followStatusLabel: 'Follow Status:',
  followStatusShort: 'Follow Status',
  followSuccess: 'Follow successful',
  followType: 'Follow Type:',
  followUp: 'Follow Up',
  followUpSuccess: 'Follow-up successful',
  /** Follow-up management list: cumulative follow-up count column */
  followUpMgmt_totalFollow: 'Total follow-ups',
  followVoucher: 'Follow Voucher',
  followVoucherLabel: 'Follow Voucher:',
  frozen: 'Frozen',
  fulltimeLabel: 'Full-time',
  galleryTypeColon: 'Type:',
  genderLabel: 'Gender: ',
  gender: 'Gender',
  getRecycleCountFail: 'Failed to get recycle count',
  getTemplateInfoFail: 'Failed to get template info',
  getTodayCountFailed: 'Failed to get today claimable count',
  goToPerfect: 'Complete',
  gotIt: 'Got it',
  grade: 'Stage Grade',
  gradeText: 'Grade',
  gradeLabel: 'Grade:',
  gradeLabelColon: 'Grade:',
  gradeLabelShort: 'Grade: ',
  gradeRequired: 'Grade is required',
  grantFail: 'Grant failed',
  grantPass: 'Grant Pass',
  grantPassTitle: 'Grant Pass',
  grantReasonLabel: 'Reason:',
  grantSuccess: 'Grant successful',
  growthReport: 'Growth Report',
  handleLater: 'Handle Later',
  hantianOutcall: 'Hantian Outcall',
  hao: 'Open Entry Account',
  haohour: 'Time to fill',
  homeAddress: 'Home Address:',
  homeAddressLabel: 'Home Address: ',
  hour: 'Report Start Time',
  houryici: 'Use the previous parameters directly',
  howToGetMore: 'How to get more examples?',
  hua: 'Call Recording',
  huashi: 'Call Duration',
  identity: 'Identity:',
  imageAddFailed: 'Failed to add image',
  imageDelete: 'Image Delete',
  imageDeleteFail: 'Image delete failed',
  imageDeleteSuccess: 'Image deleted successfully',
  imageExceed5M: 'Image exceeds 5M. Please compress before uploading!',
  imageFormatJpgJpegPng: 'Only JPG, JPEG, PNG format allowed',
  imageFormatJpgPng: 'Image must be jpg/png format!',
  imageFormatJpgPngGif: 'Image must be JPG/PNG/GIF format!',
  imageFormatOnlyJpgPng: 'Only JPG and PNG format images are allowed~',
  imageFormatTip: 'Supports jpg/png format',
  imageMaterial: 'Image Material',
  imageMax6Count: 'Maximum 6 images allowed~',
  imageMax9Count: 'Upload at most 9 images',
  imageNoDuplicate: 'Duplicate images are not allowed~',
  imageOffShelf: 'Image Off Shelf',
  imagePublish: 'Image Publish',
  imageSizeExceed10M: 'Image size exceeds 10M limit~',
  imageSizeExceeded: 'Image size cannot exceed 20MB!',
  imageSizeTip: '*Recommended image size: 1080 x 600. Click image to add markers.',
  importComplete: 'Import Complete',
  importCountTip: 'Counts newly created leads only',
  importDetail: 'Import Detail',
  importErrorTip: 'Some data has errors; if you confirm import, erroneous data will not be imported',
  importErrorTitle: 'Warning: Data errors remain',
  importQuery: 'Import Query',
  importTime: 'Import Time',
  importedCount: 'Imported',
  inactive: 'Inactive',
  infoNotExist: 'Info does not exist',
  insertText: 'Insert text',
  intentLevel: 'Intent Level:',
  intentLevelColumn: 'Intent Level',
  intentLevelChangeSuccess: 'Intent level changed successfully',
  intentLevelLabel: 'Intent Level:',
  intentLevelLabelColon: 'Intent Level:',
  intentLevelText: 'Intent Level',
  invalidReason: 'Invalid Reason',
  invalidVideoDuration: 'Video duration does not meet requirements',
  invalidVideoFormat: 'Invalid video format',
  inviteBigExam: 'Invite Big Exam',
  texttyhq: 'Invite Big Exam',
  textxdis: 'View Assignment Details',
  textaqxc: 'Invite Again',
  textl0nm: 'More',
  text9bhv: 'Growth Report',
  textaq54: 'Mark Success',
  text6sid: 'Mark Invalid',
  text5uk0: 'Cancel',
  textnfjg: 'Confirm',
  texththy: 'View Report',
  text4pq7: 'View Answer Record',
  texth0qa: 'Click to Upload',
  textf3rq: 'Invitation Successful!',
  text7tna: 'Copy',
  inviteFailed: 'Invite failed',
  inviteKnowledgeVulnExam: 'Invite Knowledge Gap Exam',
  inviteKnowledgeVulnExamSuccess: 'Knowledge gap exam invite successful!',
  inviteKnowledgeVulnExamTime: 'Invite knowledge gap exam time',
  inviteLocation: 'Invite Location',
  inviteDetail: 'Invite Detail',
  invitePhysicalExamTime: 'Invite Knowledge Gap Exam Time',
  inviteRewardTier2MoreThanTier1: 'Invite reward tier 2 must have more invites than tier 1',
  inviteRewardTier3MoreThanTier2: 'Invite reward tier 3 must have more invites than tier 2',
  inviteRewardTier4MoreThanTier3: 'Invite reward tier 4 must have more invites than tier 3',
  inviteStudentTransfer: 'Invite Student Transfer',
  inviteSuccess: 'Invite successful',
  inviteSuccessExclaim: 'Invite successful!',
  inviteSuccessTip: 'Knowledge gap exam invitation successful!',
  inviteSuccessTitle: 'Invite Knowledge Gap Exam',
  inviteTime: 'Invite Time',
  inviteTransfer: 'Invite Transfer',
  inviteTransferShort: 'Invite Transfer',
  inviteType: 'Invite Type:',
  inviteByLegacy: 'Inviter',
  ip: 'IP',
  isMultiSelect: 'Multi-select',
  isMultiSelectColumn: 'Multi-select',
  isReported: 'Is Reported',
  itemsUnit: ' items',
  ji: 'Intent Level',
  jie: 'Frozen',
  jiuyear: 'Grade 9',
  juniorHigh: 'Junior High',
  kexue: 'Science',
  labelColon: 'Tag:',
  lastCommunicateTime: 'Last Follow Time',
  lastFollowTime: 'Last Follow Time',
  lastUpdateTime: 'Last Update Time',
  lastUpdateUser: 'Last Updated By',
  latitude: 'Latitude',
  leadAssignTime: 'Lead Assign Time',
  leadCreateTime: 'Lead Create Time',
  leadDetailTitle: 'Lead Detail',
  leadIdentity: 'Lead Identity:',
  leadInfo: 'Lead Info',
  leadInfoSettingsLabel: 'Lead Info Settings',
  shareRuleSettingsLabel: 'Share Rule Settings',
  leadMarkFailedSelectReason: 'Lead mark failed. Please select invalid reason.',
  leadName: 'Lead Name:',
  leadNameColumn: 'Lead Name',
  leadNameLabel: 'Lead Name:',
  leadNameRequired: 'Lead name is required',
  leadPhone: 'Lead Phone:',
  leadPhoneAutoMatch: 'User info auto-matched by the lead phone number you entered',
  leadPhoneLabel: 'Lead Phone:',
  leadRatio: 'Lead Ratio',
  leadSourceLabel: 'Lead Source: ',
  learnCenterAccount: 'Learning Center Account',
  learningCenterAccount: 'Learning Center Account',
  learningMachine: 'Learning Machine',
  learningMachineAccountNo: 'Learning Machine Account No',
  learningMachineSn: 'Learning Machine SN',
  length2To10: 'Length must be 2-10 characters',
  li: 'Physics',
  liang: 'Collection Quantity',
  liuyear: 'Grade 6',
  loadFailed: 'Load failed',
  loadSearchResultFail: 'Failed to load search results. Please try again later!',
  location: 'Location',
  locationSource: 'Location Source',
  longTermTempPass: 'Long-term Temporary Pass',
  longitude: 'Longitude',
  ma: 'SN Code',
  machine: 'Learning Machine Account',
  machineAccount: 'Machine Account',
  machineAccountLabel: 'Machine Account:',
  machineConversionNum: 'Machine Conversion Num',
  machineConversionRate: 'Machine Conversion Rate',
  machineConversionRatio: 'Machine Conversion Ratio',
  machineManageAccount: 'Machine Account',
  machineSNCodeLabel: 'Learning Machine SN: ',
  male: 'Male',
  markAsCase: 'Mark as Case',
  markFailedSuccess: 'Marked as invalid successfully',
  markInvalid: 'Mark Invalid',
  leadInvalidConfirmTip: 'After invalidating, the lead will be treated as invalid and will no longer be shown in the lead list. Confirm to continue?',
  markInvalidFail: 'Mark invalid failed',
  markInvalidSuccess: 'Mark invalid successful',
  markPrototype: 'Mark Prototype',
  markSuccess: 'Mark successful',
  markSupervisorInfo: 'Mark Supervisor Info',
  markSupervisorStatusBtn: 'Mark Supervisor Status (Assign Service Person)',
  markSupervisorStatusTooltip: 'After marking supervisor status, analysts can filter and compare student progress under different statuses.',
  markSupervisorTooltipExpired: 'Expired: After marking validity, system auto-updates supervisor status.',
  markSupervisorTooltipExpiring: 'Expiring Soon: 14 days left until supervisor period ends.',
  markSupervisorTooltipNone: 'None: Service center does not provide supervision.',
  markSupervisorTooltipOnlineOnly: 'Online Only: Not enrolled in study room, analyst provides supervision online.',
  markSupervisorTooltipStudyRoom: 'Study Room: Student has enrolled in offline study room.',
  markSupervisorTooltipUnmarked: 'Unmarked: No supervisor status, awaiting analyst to mark.',
  markedPrototypeCount: 'Marked Prototype Count',
  markerPositionExists: 'A marker already exists at this position. Please choose another.',
  materialInterpretation: 'Material Interpretation',
  materialInterpretationPlaceholder: 'Enter material interpretation, max 500 characters',
  materialPreview: 'Material Preview',
  materialSort: 'Material Sort',
  max20Chars: 'At most 20 Chinese characters (or equivalent)',
  max28Chars: 'At most 28 Chinese characters (or equivalent)',
  max50Chars: 'At most 50 Chinese characters (or equivalent)',
  max5FilesUpload: 'Upload at most 5 files (image or PDF)',
  maxTwoExamScores: 'Select at most two exam scores',
  microFlyer: 'Micro Flyer',
  microVideo: 'Micro Video',
  min: 'Form top classification format',
  minhour: 'Course allocation time',
  minmin: 'Above is the pager part',
  minutesUnit: 'min',
  mobile: 'Mobile',
  mobileLabel: 'Mobile',
  modifySuccess: 'Modified successfully',
  month: 'undefined',
  monthRemainLimit: 'Remaining this month: ',
  monthlyRemainLimitTip: 'Monthly remaining quota: {remain}, this invite uses 1 quota',
  moreActions: 'More Actions',
  my: 'Mine',
  myLeads: 'My Leads',
  myServiceLoadFail: 'My service load failed',
  name: 'Name',
  nameColon: 'Name:',
  nameLabel: 'Name',
  nameRequired: 'Name is required',
  newActivated: 'Newly Activated',
  newLead: 'New Lead',
  newPhone: 'New Phone',
  nextCommunicateTime: 'Next Follow Time',
  nextFollowTime: 'Next Follow Time:',
  nextStep: 'Next',
  no: 'No',
  noFollowNeeded: 'No Follow Needed',
  noGrayscale: 'No Grayscale',
  noLimit: 'All',
  noMoreShareTarget: 'No more share targets',
  shareTarget: 'Share Target',
  shareTargetNotSpecified: 'Share target not specified',
  noPass: 'No Pass',
  noProvinceCrossRegion: 'No Province Cross Region',
  noRelatedInfoFound: 'No related information found',
  noSuitableReasonTip: 'If no suitable reason, you can set in Rule Settings - Invalid Reason',
  noTransferApply: 'No transfer applications',
  noValidUploadData: 'No valid data to upload',
  noVirtualPhoneForLead: 'Virtual phone number cannot be used for lead',
  nonCompliant: 'Non-compliant',
  none: 'None',
  notFilled: 'Not filled',
  notFilledFollowContent: 'Follow content not filled yet',
  notSure: 'Not sure',
  numberMax99: 'Number must be at most 99',
  offShelf: 'Off Shelf',
  offShelfSuccess: 'Off shelf successful',
  onShelf: 'On Shelf',
  onlyOneFile: 'Only one file can be uploaded',
  onlyXlsFormat: 'Only .xls format supported',
  onlyXlsXlsxFormat: 'Only xls/xlsx format supported',
  openEntryAccount: 'Open Entry Account',
  entryQuotaLabel: 'Entry Account Quota:',
  entryOpenCustomerLabel: 'Customer:',
  entryCustomerPlaceholder: 'Enter phone number or name',
  entryNoCustomerFound: 'No customer found',
  entryExperienceValidityLabel: 'Experience Validity:',
  entryLearningMachineLabel: 'Learning Machine:',
  entryMachinePlaceholder: 'Machine model or SN code',
  entryNoMachineFound: 'No learning machine found',
  entryOpenSuccessTitle: 'Entry Account Opened Successfully',
  entryCustomerNameLabel: 'Customer Name',
  entryCustomerAccountLabel: 'Customer Account',
  entryPasswordLabel: 'Password',
  entryExperienceDateLabel: 'Experience Date',
  openExperience: 'Open Experience',
  openExperienceAccount: 'Open Experience Account',
  openTime: 'Open Time',
  openExperienceAccountSuccess: 'Experience account activated successfully',
  openExperienceFailed: 'Failed to activate experience',
  openService: 'Activate Service',
  operateTime: 'Operate Time',
  operation: 'Operation',
  operationColumn: 'Operation',
  operationFail: 'Operation failed',
  operationFailed: 'Operation failed. Please try again later.',
  operationModeLabel: 'Operation Mode: ',
  operationSuccess: 'Operation successful',
  operationType: 'Operation Type',
  operationTypeImport: 'Import',
  operationTypeTip1: 'If the upload only creates new leads, the operation type is Import.',
  operationRecord: 'Record',
  operationTypeTip2: 'If the upload only updates existing leads, the operation type is Update.',
  operationTypeTip3: 'If the upload both updates existing leads and creates new leads, the operation type is Update.',
  operationTypeUpdate: 'Update',
  operator: 'Operator',
  optional: 'Optional',
  sipOptionalTip: 'SIP number (optional, fill when updating SIP)',
  orderName: 'Order Name',
  orderNo: 'Order No.',
  orderPayAmount: 'Order Amount',
  orderPayUser: 'Ordered By',
  orderStatus: 'Order Status',
  orderTime: 'Order Time',
  orderType: 'Order Type',
  addOrderRecord: 'Add Order Record',
  dealDetail: 'Deal Detail',
  addOrder: 'Add Order',
  editOrder: 'Edit Order',
  learningMachineNewSign: 'Learning Machine New Sign',
  supervisionNewSign: 'Supervision New Sign',
  supervisionRenew: 'Supervision Renew',
  learningMachineInfo: 'Learning Machine Info',
  pleaseEnterManagerMobileOrSn: 'Please enter manager mobile or SN',
  operationTip: 'Operation Tip',
  confirmDeleteOrder: 'Confirm to delete order?',
  originalPhone: 'Original Phone',
  other: 'Other',
  otherInfo: 'Other Info',
  outboundExpiredCannotRenew: 'You are not within the service validity period. Please reactivate the service',
  outboundNotOpened: 'Outbound service not activated yet. Please activate before recharging',
  outboundOpening: 'Outbound service is being activated. Expected within 7 business days. Please recharge after activation',
  ownerTime: 'Assign Time',
  ownerTimeLabel: 'Assign Time',
  packageRemainingMinutes: 'Remaining Minutes',
  parentAgentId: 'Parent Agent ID',
  parentAgentName: 'Parent Agent Name',
  participationExportFilename: 'Participation Export {time}.xls',
  participationPageTitle: 'Activity Participation',
  passHolding: 'Pass Held',
  passStatusLabel: 'Pass Status:',
  passStatusColumn: 'Pass Status',
  passStatusTable: 'Pass Status',
  passportStatus: 'Pass Status',
  passportStatusNone: 'None',
  passportStatusPass: 'Pass Held',
  passportStatusTemp: 'Temporary Pass',
  passwordLabel: 'Password',
  paySettings: 'Payment Settings',
  paymentFail: 'Payment failed',
  pending: 'Pending Release',
  pendingAllocate: 'Pending Assign',
  pendingFollow: 'Pending Follow',
  pendingPublish: 'Pending Publish',
  inProgress: 'In Progress',
  paused: 'Paused',
  ended: 'Ended',
  wechatScanPreview: 'Scan with WeChat to preview',
  downloadActivityQRCode: 'Download Activity QR Code',
  downloadQrCode: 'Download QR code',
  pauseActivity: 'Pause Activity',
  pause: 'Pause',
  startActivity: 'Start Activity',
  start: 'Start',
  activityPreview: 'Activity Preview',
  activityParticipationDetail: 'Participation Detail',
  activityEdit: 'Edit Activity',
  publishActivityTip: 'After publishing, students can view and join the activity. Confirm publish?',
  publishActivityTitle: 'Publish Activity',
  publishSuccessTip: 'You can download the activity QR code for promotion, or view participation details in the list.',
  publishSuccessTitle: 'Activity Published',
  confirmDeleteActivityTip: 'Confirm delete activity?',
  activityDeleteTitle: 'Delete Activity',
  confirmPauseActivityTip: 'Confirm pause activity?',
  confirmActivityToggleTip: 'Are you sure you want to {action} this activity?',
  pauseActivityTitle: 'Pause Activity',
  confirmStartActivityTip: 'Confirm start activity?',
  startActivityTitle: 'Start Activity',
  perfectSuccess: 'Profile completed successfully',
  perfectUserProfile: 'Complete User Profile',
  person: 'Person',
  phoneBillBalance: 'Phone Balance',
  phoneLabel: 'Phone:',
  phoneNotVerified: 'Customer phone number is not verified.',
  picture: 'Picture',
  planTime: 'Planned Time',
  pleaseAddRepairDetail: 'Add repair detail',
  pleaseAddStudentStory: 'Please add student story',
  pleaseCheckOutboundProtocol: 'Please read and check the outbound service agreement first',
  pleaseCompleteUserProfile: 'Please complete user profile first',
  pleaseEditStudentScore: 'Please edit student score',
  pleaseEnter: 'Please enter activity ID',
  pleaseEnter4DigitCode: 'Enter 4-digit verification code',
  pleaseEnterActivityDesc: 'Enter activity description',
  pleaseEnterActivityName: 'Enter activity name',
  pleaseEnterActivityPrize: 'Enter activity prize',
  pleaseEnterActivityRules: 'Enter activity rules',
  pleaseEnterActivityTag: 'Enter activity tag',
  pleaseEnterActivityTitle: 'Enter activity title',
  pleaseEnterAdapAccount: 'Enter adaptive account',
  pleaseEnterAgencyAddress: 'Enter agency address',
  pleaseEnterAgencyContact: 'Enter agency contact',
  pleaseEnterAgencyIntro: 'Enter agency introduction',
  pleaseEnterAgencyName: 'Enter agency name',
  pleaseEnterApplyReason: 'Enter application reason',
  pleaseEnterApplySuccessMsg: 'Enter registration success message',
  pleaseEnterApplySuccessReminder: 'Please enter apply success reminder',
  pleaseEnterBriefIntro: 'Enter brief introduction',
  pleaseEnterButtonName: 'Enter button name',
  pleaseEnterCancelReason: 'Enter cancel reason',
  pleaseEnterCaseTitle: 'Enter case title',
  campusCaseCreatorLabel: 'Student location',
  campusCaseCreatorPlaceholder: 'Select province and city',
  campusCaseLabelSubject: 'Subject:',
  campusCaseLabelProgressScore: 'Progress score:',
  campusCaseLabelEnrolScore: 'Entrance score:',
  campusCaseSortTitleWithColon: 'Sort:',
  campusCaseFilterResultBefore: 'Filter matches ',
  campusCaseFilterResultAfter: ' results',
  campusCaseFilterCollapse: 'Collapse options',
  campusCaseFilterMore: 'More options',
  pleaseEnterCatalogName: 'Enter catalog name',
  pleaseEnterCatalogSort: 'Enter catalog sort order',
  pleaseEnterCategoryName: 'Enter non-empty category name',
  pleaseEnterClassFrequency: 'Enter class frequency',
  pleaseEnterClassNum: 'Enter class count',
  pleaseEnterContact: 'Enter contact name',
  pleaseEnterContactMethod: 'Enter contact method',
  pleaseEnterContactNumber: 'Please enter contact number for users',
  pleaseEnterContent: 'Enter content',
  pleaseEnterCorrectAmount: 'Enter correct amount',
  pleaseEnterCorrectCustomerInfo: 'Please enter correct customer info',
  pleaseEnterCorrectMachineInfo: 'Please enter correct machine info',
  learningMachineInfoInvalid: 'The learning machine info you uploaded is invalid',
  pleaseEnterCorrectPeriod: 'Enter correct period',
  pleaseEnterCorrectPhone: 'Enter correct phone number',
  pleaseEnterCorrectSN: 'Enter correct SN code',
  pleaseEnterCounterAddress: 'Enter counter address',
  pleaseEnterCounterManagerName: 'Enter counter manager name',
  pleaseEnterCounterManagerPhone: 'Enter counter manager phone',
  pleaseEnterDescription: 'Enter description',
  pleaseEnterDetailAddress: 'Enter detail address',
  pleaseEnterDeviceSN: 'Please enter device SN',
  pleaseEnterEnrollmentScore: 'Enter enrollment score',
  pleaseEnterFamilyMember1Phone: 'Please enter family member 1 phone',
  pleaseEnterFamilyMember2Phone: 'Please enter family member 2 phone',
  pleaseEnterFamilyMemberPhone: 'Please enter family member {n} lead phone',
  pleaseEnterFinalScore: 'Enter final score',
  pleaseEnterFollowContent: 'Please enter follow content',
  pleaseEnterFollowType: 'Please enter follow type',
  pleaseEnterFullMarks: 'Enter full marks',
  pleaseEnterHandwrittenEssay: 'Enter handwritten essay',
  pleaseEnterHomeAddress: 'Enter home address',
  pleaseEnterImageName: 'Enter image name',
  pleaseEnterInviteLocation: 'Enter invite location',
  pleaseEnterLapseReason: 'Please enter invalid reason',
  pleaseEnterLeadName: 'Please enter lead name',
  pleaseEnterLeadNameOrPhone: 'Enter prospect name or phone',
  pleaseEnterLearningMachineInfo: 'Enter learning machine info',
  pleaseEnterLearningMachineSn: 'Enter learning machine SN',
  pleaseEnterLeftTitle: 'Enter left title',
  pleaseEnterLegalName: 'Enter valid name',
  pleaseEnterMachineAccount: 'Please enter machine account',
  pleaseEnterSNCode: 'Please enter SN code',
  materialNameLabel: 'Material Name',
  pleaseEnterMaterialName: 'Enter material name',
  pleaseEnterMaterialSort: 'Please enter material sort',
  pleaseEnterMonthNum: 'Please enter activation months first',
  pleaseEnterName: 'Enter name',
  pleaseEnterNameOrPhone: 'Enter name or phone',
  pleaseEnterNamePlaceholder: 'Enter {type} name',
  pleaseEnterNameRule: 'Enter Chinese, digits, letters, underscore or dot',
  pleaseEnterNewPhone: 'Please enter new phone',
  pleaseEnterNewStudentName: 'Enter new student name',
  pleaseEnterNotice: 'Enter notice',
  pleaseEnterOriginalPhone: 'Please enter original phone',
  pleaseEnterPageDesc: 'Enter page description',
  pleaseEnterPageName: 'Enter page name',
  pleaseEnterPassword: 'Enter password',
  pleaseEnterPassword6_32: 'Enter 6-32 character password (digits or letters only)',
  pleaseEnterPhone: 'Enter phone number',
  pleaseEnterPhoneFirst: 'Enter phone number first',
  pleaseEnterPromoterName: 'Enter promoter name',
  pleaseEnterQrCodeIntro: 'Enter QR code introduction',
  pleaseEnterReason: 'Enter reason',
  pleaseEnterReason5to100: 'Enter reason (5-100 characters)',
  pleaseEnterReceiverPhone: 'Enter receiver phone',
  pleaseEnterRegistrationInfo: 'Enter registration info',
  pleaseEnterRejectReason: 'Please enter reject reason',
  pleaseEnterRemarkPlaceholder: 'Enter remark',
  pleaseEnterReportReason: 'Enter report reason',
  pleaseEnterSN: 'Please enter SN code',
  pleaseEnterSNOrTimeToExport: 'Please enter SN code or select creation time to export',
  pleaseEnterSchoolName: 'Enter school name',
  pleaseEnterScore: 'Enter score',
  pleaseEnterServiceCenterName: 'Enter service center name',
  pleaseEnterShipAddress: 'Enter shipment address',
  pleaseEnterSourceName: 'Enter source name',
  pleaseEnterStoreName: 'Enter store name',
  pleaseEnterStudentAccountFirst: 'Please enter student account first',
  pleaseEnterStudentAccountOrName: 'Please enter student account or name',
  pleaseEnterStudentNameOrPhone: 'Enter student name/phone',
  pleaseEnterStudentName: 'Enter student name',
  pleaseEnterStudentPhone: 'Enter student phone',
  pleaseEnterStudentScoreInfo: 'Please enter student score info',
  pleaseEnterSubjectTotalScore: 'Enter subject total score',
  pleaseEnterSupervisorFee: 'Enter supervisor fee',
  pleaseEnterTagName: 'Enter tag name',
  pleaseEnterTagNamePlaceholder: 'Enter tag name',
  pleaseEnterTemplateName: 'Enter template name',
  pleaseEnterTemplateNameSearch: 'Enter template name',
  pleaseEnterTitle: 'Enter title',
  pleaseEnterUser: 'Enter user',
  pleaseEnterValidAdaptiveAccount: 'Please enter valid adaptive account',
  pleaseEnterValidContactNumber: 'Please enter a valid contact number',
  pleaseEnterValidNumber: 'Enter valid number',
  pleaseEnterValidPhone: 'Please enter valid phone number',
  pleaseEnterValidPhoneNum: 'Enter valid phone number',
  pleaseEnterValidRechargeAmount: 'Please enter a valid recharge amount first',
  pleaseEnterVerifyAddress: 'Please enter verify address',
  pleaseEnterVerifyCode: 'Enter verification code',
  pleaseEnterWeeklyFoundationHours: 'Enter weekly foundation hours',
  pleaseFill2_50Chars: 'Enter 2-50 characters',
  pleaseFillActivityDesc: 'Please fill in activity description',
  pleaseFillActivityName: 'Please fill in activity name',
  pleaseFillActivityRules: 'Please fill in activity rules',
  pleaseFillActivityTitle: 'Please fill in activity title',
  pleaseFillAdaptiveAccount: 'Fill in adaptive account',
  pleaseFillAdaptiveAccountShort: 'Please fill in adaptive account',
  pleaseFillAgencyAddress: 'Please fill in agency address',
  pleaseFillAgencyContact: 'Please fill in agency contact',
  pleaseFillAgencyIntro: 'Please fill in agency introduction',
  pleaseFillCaseSettingsFirst: 'Please fill in case settings first',
  pleaseFillFollowContent: 'Enter follow content',
  pleaseFillInviteRewardRule: 'Please fill in the first tier activity rules for invite rewards',
  pleaseFillMarkerContent: 'Please fill in marker content',
  pleaseFillProgressPlan: 'Please fill in progress plan',
  pleaseFillRemarkFirst: 'Please fill in remark first',
  pleaseFillShareRatio: 'Please fill in {name} share ratio',
  pleaseEnterShareRatio: 'Please enter share ratio',
  pleaseFillStoreRewardRule: 'Please fill in the first tier activity rules for in-store rewards',
  pleasePerfectUserProfile: 'Please complete user profile first',
  pleasePerfectUserProfileFor: 'Please complete user profile for {name} first',
  pleasePerfectUserProfileSimple: 'Please complete user profile',
  pleaseSearchAccount: 'Please search account',
  pleaseSelect: 'Please select',
  pleaseSelectAccountStatus: 'Please select account status',
  pleaseSelectActivityEndTime: 'Select activity end time',
  pleaseSelectActivityFollower: 'Please select activity follower',
  pleaseSelectActivityStartTime: 'Select activity start time',
  pleaseSelectActivityTime: 'Select activity time',
  pleaseSelectAgent: 'Please select agent',
  pleaseSelectAgentFirst: 'Please select agent to assign first',
  pleaseSelectAnalyst: 'Please select analyst',
  pleaseSelectAppointmentTime: 'Select appointment time',
  pleaseSelectAssignAnalyst: 'Select analyst to assign',
  pleaseSelectAssignPerson: 'Please select assign person',
  pleaseSelectBgColor: 'Select background color',
  pleaseSelectBirthDate: 'Select birth date',
  pleaseSelectBusinessStatus: 'Select business status',
  pleaseSelectCallStatus: 'Select call status',
  pleaseSelectCatalog: 'Please select catalog category',
  pleaseSelectChangeReason: 'Select change reason',
  pleaseSelectChannel: 'Select channel',
  pleaseSelectCounterType: 'Select counter type',
  pleaseSelectCrossRegionType: 'Please select cross region type',
  pleaseSelectCustomerChannel: 'Please select customer channel',
  pleaseSelectDate: 'Select date',
  pleaseSelectDeviceToSelected: 'Please select device to selected area!',
  pleaseSelectDisplayStatus: 'Please select display status',
  pleaseSelectDoubleOrder: 'Select whether to enable double order',
  pleaseSelectEnrollmentGrade: 'Select enrollment grade',
  pleaseSelectExamDate: 'Select exam date',
  pleaseSelectExamType: 'Select exam type',
  pleaseSelectExchangeIn: 'Please select exchange in product',
  pleaseSelectExchangeOut: 'Please select exchange out product',
  pleaseSelectExperienceAnalyst: 'Select experience analyst',
  pleaseSelectExperienceDate: 'Select experience date',
  pleaseSelectFamilyMemberRelation: 'Please select family member {n} relation',
  pleaseSelectFileType: 'Select file type',
  pleaseSelectFirstLevelTag: 'Select first-level tag',
  pleaseSelectFollowPerson: 'Please select follow person',
  pleaseSelectFollowStatus: 'Select follow status',
  pleaseSelectFollowType: 'Select follow type',
  pleaseSelectFollower: 'Please select follower',
  pleaseSelectGradeFirst: 'Select grade first',
  pleaseSelectIdentityType: 'Please select identity type',
  pleaseSelectIntentLevel: 'Select intent level',
  pleaseSelectInvalidReason: 'Select invalid reason',
  pleaseSelectInviteDate: 'Select invite date',
  pleaseSelectInviteType: 'Select invite type',
  /** Invite Big Exam — success dialog (dedicated keys) */
  inviteBigExamSuccessDialogTitle: 'Knowledge gap full checkup',
  inviteBigExamSuccessTopic: 'Knowledge gap full checkup invitation succeeded!',
  inviteBigExamAppointmentTimeLabel: 'Invited checkup session time',
  inviteBigExamKnow: 'Got it',
  pleaseSelectInviter: 'Select inviter',
  pleaseSelectIsMultiSelect: 'Please select multi-select option',
  pleaseSelectLabel: 'Select tag',
  pleaseSelectLocation: 'Select location',
  pleaseSelectOperationMode: 'Select operation mode',
  pleaseSelectOperator: 'Select operator',
  pleaseSelectOrderSplitType: 'Select order split type',
  orderSplitType: 'Order Split',
  independentComplete: 'Independent Complete',
  collaborationSplit: 'Collaboration Split',
  pleaseSelectOrderStatus: 'Select order status',
  pleaseSelectOrderType: 'Select order type',
  pleaseSelectPageCategory: 'Select page category',
  pleaseSelectPassStatus: 'Select pass status',
  pleaseSelectPerson: 'Select person',
  pleaseSelectPrincipal: 'Select principal',
  pleaseSelectPrototypeType: 'Please select prototype type',
  pleaseSelectProvinceCity: 'Select province/city',
  pleaseSelectQuota: 'Please select quota',
  pleaseSelectRankTime: 'Select rank time',
  pleaseSelectRealNameStatus: 'Select real-name verification status',
  pleaseSelectRecycleReason: 'Select recycle reason',
  pleaseSelectRegistrationInfo: 'Please select registration info',
  pleaseSelectReportActivateArea: 'Select report activation area',
  pleaseSelectReviewResult: 'Please select review result',
  pleaseSelectScheduleDate: 'Select schedule date',
  pleaseSelectScheduleTime: 'Please select schedule time',
  pleaseSelectSchool: 'Select school',
  pleaseSelectServicePerson: 'Select service person',
  pleaseSelectShipStatus: 'Select shipment status',
  pleaseSelectShipWarehouse: 'Select shipment warehouse',
  pleaseSelectSigningParty: 'Select signing party',
  pleaseSelectSoftwareActiveStatus: 'Please select software active status',
  pleaseSelectSource: 'Please select source',
  pleaseSelectStage: 'Select stage',
  pleaseSelectStageExam: 'Select stage',
  pleaseSelectStageFirst: 'Select stage first',
  pleaseSelectStageGrade: 'Select stage/grade',
  pleaseSelectStartEndTime: 'Please select start and end time',
  pleaseSelectStatus: 'Please select status',
  pleaseSelectStudent: 'Please select student',
  pleaseSelectStudentFirst: 'Please select student',
  pleaseSelectStudentToClaim: 'Please select students to claim first',
  pleaseSelectStudyTime: 'Select study time',
  pleaseSelectSubTag: 'Select sub tag',
  pleaseSelectSubject: 'Select subject',
  pleaseSelectSyncCourseStatus: 'Select sync course status',
  pleaseSelectTag: 'Select tag',
  pleaseSelectTagType: 'Select tag type',
  pleaseSelectTemplateStatus: 'Select template status',
  pleaseSelectTemplateType: 'Select template type',
  pleaseSelectTestConfirmTime: 'Select test confirm time',
  pleaseSelectTestStatus: 'Select test status',
  pleaseSelectVisitStore: 'Select visit store',
  pleaseSelectYear: 'Select year',
  pleaseSetActivitySpecifiedTime: 'Please set the specified time for the activity',
  pleaseSetActivityTime: 'Please set activity time',
  pleaseSetQueryFirst: 'Please set query conditions first',
  pleaseStartOutboundFirst: 'Please click "Start Outbound" in the top right corner before making calls',
  pleaseUploadAgreement: 'Please upload agreement before saving!',
  pleaseUploadFaultImage: 'Upload fault image',
  pleaseUploadFile: 'Please upload file',
  pleaseUploadFileImagePdf: 'Upload file (image or PDF)',
  pleaseUploadFirstDiagnosisMedia: 'Upload first diagnosis image/video',
  pleaseUploadImage: 'Please upload image',
  pleaseUploadImageFormat: 'Invalid image format. Please upload jpg/png/jpeg',
  pleaseUploadInspectionMedia: 'Upload quality inspection image/video',
  pleaseUploadMaterial: 'Please upload material',
  pleaseUploadParentFeedback: 'Please upload parent feedback',
  pleaseUploadVideo: 'Please upload video',
  pleaseUploadVideoFormat: 'Please upload video in mp4/mov format',
  pleaseVerifyDeviceSn: 'Please verify device SN first',
  preview: 'Preview',
  previewImage: 'Preview image',
  previewTemplateTitle: 'Template Preview',
  previewTitle: 'Preview',
  primarySchool: 'Primary School',
  productName: 'Product Name',
  pleaseEnterProductName: 'Please enter product name',
  profileComplete: 'Complete',
  profileIncomplete: 'Incomplete',
  progressOperator: 'Operator',
  promisedVisitTime: 'Promised Visit Time:',
  promisedVisitTip: 'Time customer promised to visit store',
  promoteCount: 'Promote Count',
  promoterQuery: 'Promoter Query:',
  prototypeNote1: '1. Once marked as prototype, cannot be modified;',
  prototypeNote2: '2. Prototype cannot be sold, only for experience and display;',
  prototypeNote3: '3. Each prototype can only bind one learning account;',
  prototypeNote3Sub: 'If the device has multiple accounts, keep one and unbind the others when marked as prototype;',
  prototypeNoteLabel: 'Note:',
  prototypeProductModelLabel: 'Product Model:',
  prototypeSNCode: 'Prototype SN Code',
  prototypeDeviceSNLabel: 'Device SN:',
  prototypePleaseEnterDeviceSN: 'Please enter device SN',
  prototypeTypeLabel: 'Prototype Type:',
  prototypePleaseSelectType: 'Please select prototype type',
  prototypeDispatchedCountLabel: 'Dispatched Prototype Count:',
  prototypeMarkedCountLabel: 'Marked Prototype Count:',
  prototypeAvailableCountLabel: 'Available Prototype Count:',
  prototypeRenewal: 'Prototype Renewal',
  prototypeRenewalApply: 'Prototype Renewal Application',
  prototypeType: 'Prototype Type',
  provinceCity: 'Province/City/District',
  provinceCityLabel: 'Province/City:',
  publicPool: 'Public Pool',
  publicSchoolStage: 'Public School Stage',
  publish: 'Publish',
  publishFailed: 'Publish failed',
  publishSuccess: 'Published successfully',
  published: 'Published',
  purchaseSuccess: 'Purchase successful',
  qi: 'Buffer Period',
  qiyear: 'Grade 7',
  qrcodeGenerateFail: 'QR code generation failed. Please try again',
  qu: 'Collector',
  queryFailed: 'Query Failed',
  queryFollowRemindFail: 'Failed to query follow reminder',
  queryLearningTrackFail: 'Failed to query learning track',
  queryProgressScoreFail: 'Failed to query progress score',
  queryScoreFail: 'Failed to query score',
  querySuccess: 'Query successful',
  quickFilter: 'Quick Filter:',
  ququ: 'Cross-region Active Province/City/District',
  reUpload: 'Re-upload',
  realNameStatusLabel: 'Real-name Face Verified',
  realNameStatusTable: 'Real-name Verified',
  reason: 'Reason',
  reasonLength5_100: 'Reason must be 5-100 characters',
  recallConfirmTip: 'You have selected {n} leads. After recall, they will be unassigned. Confirm to continue?',
  recallReminder: 'Recall Reminder',
  receive: 'Claim',
  receiveFailed: 'Claim failed',
  receiveSuccess: 'Claim successful',
  rechargePhoneBill: 'Top up',
  recycleBin: 'Recycle Bin',
  recycleReason: 'Recycle Reason',
  recycleTime: 'Recycle Time',
  recycleTimeRange: 'Recycle Time Range:',
  registerTime: 'Register Time',
  reject: 'Reject',
  rejectReasonLabel: 'Reject Reason:',
  rejectReasonPlaceholder: 'If rejecting, enter reason (will be sent to applicant). Max 50 chars',
  releaseConfirmTip: 'You have selected {n} leads. After release, you will no longer follow them. Confirm to continue?',
  remark: 'Remark',
  remarkFail: 'Remark failed',
  remarkLabel: 'Remark',
  remarkSuccess: 'Remark successful',
  renewService: 'Renew Service',
  renewalBtn: 'Renew',
  renewSuccess: 'Renew successful',
  renqu: 'Current Certification Area',
  replace: 'Replace',
  reportActiveLocation: 'Report Active Location',
  reportAgain: 'Report Again',
  reportBy: 'Report By',
  reportLocalAgentId: 'Report Local Agent ID',
  reportLocalAgentName: 'Report Local Agent Name',
  reportReason: 'Report Reason',
  reportTime: 'Report Time',
  requestFailed: 'Request failed',
  resendAfterSeconds: 'Resend in {n}s',
  resendAfterSecondsShort: 'Resend in {n}s',
  restoreCluesTip: 'Tip',
  resultPreview: 'Result Preview',
  resultScoreFormatError: 'Result score format incorrect',
  reviewResult: 'Review Result',
  reviewTime: 'Review Time',
  reviewer: 'Reviewer',
  revokeApply: 'Revoke Application',
  revokeApplyFailed: 'Revoke application failed',
  revokeApplySuccess: 'Application revoked successfully',
  ronglianOutcall: 'Ronglian Outcall',
  ru: 'Incoming Call',
  ruxue: 'Entrance Score',
  sale: 'Sales Person',
  saleName: 'Sales Person',
  san: 'Grade 3',
  sanyear: 'Grade 3',
  gaoyi: 'Senior 1',
  gaoer: 'Senior 2',
  gaosan: 'Senior 3',
  gaosi: 'Senior 4',
  save: 'Save',
  textd4oi: 'Save',
  texttx2k: 'Attachment',
  saveAndPublishFail: 'Save and publish failed',
  saveSuccess: 'Saved successfully',
  saveStudyScore: 'Save study scores',
  scheduleTime: 'Schedule Time',
  testConfirm: 'Test Confirmation',
  testConfirmTime: 'Test Confirmation Time',
  textxan7: 'Test Report',
  textyrvw: 'Test Confirmation',
  text40sp: 'Cancel',
  textol3p: 'View Report',
  textt828: 'View Plan Report',
  text93h4: 'Invite Again Success',
  textq0g4: 'Validity Period',
  textpuet: 'Counter store',
  text2hfg: 'Copy',
  textw3pi: 'OK',
  inviteExperienceSuccess: 'Invite Experience Success',
  inviteExperience: 'Invite Experience',
  customerList: 'Customer List',
  experienceCourse: 'Experience Course',
  experienceStartDate: 'Experience Start Date',
  selectCourseSubject: 'Select Course Subject',
  pleaseSelectCourseSubject: 'Please select course subject',
  pleaseSelectExperienceStatus: 'Please select experience status',
  pleaseSelectStageFirst: 'Please select stage first',
  pleaseSelectCourse: 'Please select course',
  scheduleTimeMustBeFuture: 'Selected time must be after current time',
  school: 'School',
  schoolAddress: 'School Address',
  schoolAddressLabel: 'School address:',
  schoolApplication: 'School Application',
  schoolArea: 'School Area',
  schoolDetailAddress: 'School Address',
  schoolId: 'School ID',
  schoolLabel: 'School:',
  schoolLabel2: 'School:',
  schoolLabelShort: 'School: ',
  schoolName: 'School Name',
  schoolApplicationSchoolName: 'School Name',
  schoolNameLabel: 'School Name',
  schoolNameTip: 'Enter full public school name, avoid abbreviations',
  schoolPlaceholder: 'School',
  schoolScale: 'School Scale',
  schoolStage: 'School Stage',
  schoolStageLabel: 'School stage:',
  scoreFormatError: 'Invalid format. Up to 3 digits + 1 decimal',
  scoreProgressRequired: 'Score progress is required',
  scoreProgressLabel: 'Score Progress',
  scoringRateLabel: 'Scoring rate',
  search: 'Search Student:',
  searchByChargeNamePhone: 'Search by name or phone',
  searchByCounterNo: 'Search by counter no.',
  searchCustomer: 'Search Customer:',
  searchCustomerLabel: 'Search Customer:',
  searchSchool: 'Search School',
  searchStudent: 'Search Student',
  selectActualVisitTime: 'Select actual visit time',
  selectDate: 'Select date',
  selectDateTime: 'Select date/time',
  selectNextFollowTime: 'Select next follow time',
  selectPromisedVisitTime: 'Select promised visit time',
  selectSchoolLabel: 'Select school:',
  selectStage: 'Select stage',
  selectSuccess: 'Select successful',
  selectedItems: 'Selected',
  sendVerifyCode: 'Send Code',
  sendVerifyCodeSuccess: 'Verification code sent',
  seniorHigh: 'Senior High',
  serviceAbnormal: 'Service abnormal. Please try again later',
  serviceExpireTip: 'Current service {already} expires on {time}',
  /** Cost center outbound: date wrapped with .expired-time in CostCenter only */
  costServiceActiveBefore: 'Current service expires on ',
  costServiceActiveAfter: '.',
  costServiceExpiredBefore: 'Current service expired on ',
  costServiceExpiredAfter: '.',
  servicePerson: 'Service Person:',
  servicePersonLabel: 'Service Person:',
  servicePersonTable: 'Service Person',
  serviceTerminated: 'Service Terminated',
  serviceVersion: 'Service Version',
  sexLabel: 'Gender:',
  sheng: 'Biology',
  shortTermTempPass: 'Short-term Temporary Pass',
  shu: 'Promote Count',
  shuxue: 'Mathematics',
  siyear: 'Grade 4',
  sizeLimit: ', max 5MB',
  snCode: 'SN Code',
  snCodeLabel: 'SN Code:',
  softwareActivateTime: 'Software Activate Time',
  softwareActiveStatus: 'Software Active Status',
  sortPlaceholder: '1-98',
  source: 'Source:',
  sourceColumn: 'Source',
  sourceRequired: 'Source is required',
  stage: 'undefined',
  stageGrade: 'Stage/Grade',
  stageGradeLabel: 'Stage/Grade:',
  stageGradeLabel2: 'Stage/Grade:',
  stageGradeLabelShort: 'Stage/Grade',
  stageGradeRequired: 'Stage/grade is required',
  stageGradeTable: 'Stage Grade',
  stageGradeTable2: 'Stage/Grade',
  startDate: 'Start Date',
  statsPeriod: 'Stats Period:',
  status: 'Status',
  statusColon: 'Status:',
  storageTime: 'Storage Time',
  storeRewardTier2MoreThanTier1: 'Store reward tier 2 must have more invites than tier 1',
  storeRewardTier3MoreThanTier2: 'Store reward tier 3 must have more invites than tier 2',
  storeRewardTier4MoreThanTier3: 'Store reward tier 4 must have more invites than tier 3',
  student: 'Student Account',
  studentAccount: 'Student Account',
  studentAccountLabel: 'Student Account:',
  studentAccountNotObtained: 'Student account not obtained',
  studentIdRequired: 'Student ID is required!',
  studentInfo: 'Student Info',
  leadNameEditOnceTip: 'Lead name can only be edited once',
  nameEditUpToThreeTimesTip: 'Name can only be edited up to three times',
  gradeEditOnceTip: 'Grade can only be edited once',
  studentIntroLength: 'Student intro 50~2000 characters',
  studentName: 'Student Name',
  studentNameLabel: 'Student Name: ',
  studentNameLabelColon: 'Student Name:',
  studentNameOrPhone: 'Student Name/Phone:',
  studentNameRequired: 'Student name is required',
  studentStoryMin50Chars: 'Student story must be at least 50 characters',
  studentTransferApply: 'Student Transfer Application',
  subTagColumn: 'Sub Tag',
  subTagLabel: 'Sub Tag:',
  subTagNameRequired: 'Sub tag name is required',
  subject: 'Subject',
  subjectTotalPositiveInteger: 'Subject total must be a positive integer',
  subjectTotalScorePositiveInteger: 'Subject total score must be a positive integer',
  submitAudit: 'Submit for Audit',
  submitAuditFailed: 'Submit for audit failed',
  submitAuditSuccess: 'Submitted for audit successfully',
  submitFailed: 'Submit failed',
  submitNow: 'Submit Now',
  submitSuccess: 'Submit successful',
  subscribed: 'Subscribed',
  subscriptionSubject: 'Subscription Subject',
  success: 'Success',
  suochaxun: 'Clue Query',
  pleaseEnterClueNameOrMobile: 'Enter clue name or mobile number',
  supervisionFeeRequired: 'Supervision fee is required',
  supervisionFeeLabel: 'Supervision Fee',
  supervisionRenewConflict: 'Supervision renew cannot coexist with new machine/study sign',
  supervisorConversionNum: 'Supervisor Conversion Num',
  supervisorConversionRate: 'Supervisor Conversion Rate',
  supervisorConversionRatio: 'Supervisor Conversion Ratio',
  supervisorExpireTo: 'Supervisor Valid Until',
  supervisorExpireToTable: 'Supervisor Valid Until',
  supervisorStatusLabel: 'Supervisor Status:',
  markSupervisorNoneDetailTip: 'After selecting No Supervision, the system will automatically unbind the student from the analyst. You can follow up this student in "Large Model Data Analysis Service System - Unsupervised Students".',
  unsupervisedStudentDataTipDetail: 'For unsupervised student analytics, go to "Large Model Data Analysis Service System - Unsupervised Students".',
  supervisorValidDateLabel: 'Supervisor Validity Period:',
  supervisorExpireNextDayTip: 'On the day after supervision end time, customer supervision status will automatically change to "Supervision Expired".',
  supervisorStoreLabel: 'Supervisor Store:',
  pleaseSelectSupervisorStore: 'Please select supervisor store',
  remarkLabelWithColon: 'Remark:',
  syncCourseStatusLabel: 'Sync Course Status:',
  syncCourseStatusTable: 'Sync Course Status',
  systemError: 'System error',
  tagCategoryLabel: 'Tag Category:',
  tagLabel: 'Tags:',
  tagLabelShort: 'Tags: ',
  tagNameLabel: 'Tag Name:',
  tagTypeColumn: 'Tag Type',
  taskStatusLabel: 'Task Status',
  tempPassHolding: 'Temp Pass',
  tempPassTip: 'Temporary pass allows students who have not met learning standards to continue studying. Please issue with caution.',
  tempPassTypeLabel: 'Pass Type:',
  templateBgColor: 'Background Color:',
  templateDelete: 'Template Delete',
  templateNameLabel: 'Template Name:',
  templateNameSearchLabel: 'Template Name:',
  templateOffShelf: 'Template Off Shelf',
  templateOffShelfSuccess: 'Off shelf successful',
  templatePublish: 'Template Publish',
  templateSaveSuccess: '{flag} successful',
  templateTip: 'Please download the latest template and do not modify or delete the first two rows',
  templateTypeLabel: 'Template Type:',
  templateListTemplateTypeLabel: 'Template type:',
  templateListPleaseSelectTemplateType: 'Please select template type',
  templateListTagSelectPlaceholder: 'Tag',
  testStatus: 'Test Status',
  testTime: 'Test Time',
  text0b7p: 'Tag',
  text0bq4: 'Improve',
  text0pmo: 'Search Parameters',
  text0rj0: 'All',
  textys3t: 'Subject',
  textys4t: 'Learning Subject',
  text7041: 'Progress Achievement',
  texty59e: 'Admission Achievement',
  textxjvh: 'Sort',
  text0zrv: 'Keep Empty',
  text115o: 'View Report',
  text126z: 'Get Table Data',
  text14yy: 'Manufacturer Return/Exchange',
  text1609: 'Default',
  text16d6: 'Report Type',
  text1dm0: 'Gift Claim Status',
  text1g8k: 'Stage List',
  text1h2y: 'Attention',
  text1sge: 'Scan to view case details',
  scoreCaseCardTooltipViews: 'Views',
  scoreCaseCardTooltipCollects: 'Collections',
  scoreCaseCardTooltipShares: 'Shares',
  scoreCaseCardTooltipCampusUse: 'Campuses using case',
  scoreCaseCardStudyDaysLabel: 'Study days',
  scoreCaseCardDownloadPoster: 'Download poster and share with friends',
  scoreCaseCardShareImageFileName: 'case-share.png',
  scoreCaseCardDayUnit: 'days',
  scoreCaseCardTitleDaysImprove: '{days}-day improvement',
  scoreCaseCardTitleScorePoints: '{score} pts',
  scoreCaseCardTagScoreGain: '+{score} pts',
  scoreCaseCardTagDaysSinceEnroll: '{days} days since start',
  scoreCaseCardScoreWithUnit: '{score} pts',
  text1tpq: 'Close preview',
  text1uvl: 'Filter Value',
  text245v: 'Process checkbox changes and update search parameters',
  text29q9: 'Optional',
  text2chn: 'Current Filter Result',
  text2ffx: 'Select All',
  text2kky: 'Do not write randomly',
  text2m1b: 'Here', 
  text2n18: 'Student Score', 
  text2oge: 'School Label',
  text2u5x: 'After Cancel',
  text2v8u: 'Data Length', 
  text30tx: 'Server Type',
  text39fb: 'Enter Student Story',
  text3l9l: 'Table Operations',
  text3pnx: 'Songshu',
  text3qnn: 'Required Fields',
  text3qx2: 'Learning Subject',
  text3uew: 'Sort',
  text3w27: 'Report Name',
  text41s1: 'Search Content',
  text429c: 'Form',
  text4a3g: 'Search Condition Changed',
  text47n0: 'Community store',
  text4if3: 'Result Description',
  text4l7a: 'Classic Case',
  text4lpi: 'Knowledge Points',
  text4r37: 'CourseType',
  text5bx8: 'Update',
  text5fi2: 'Here',
  text5jly: 'Get Subject List',
  text5mof: 'Audit Status',
  text5mwq: 'Conversion Rate',
  text5pnc: 'Click to view the details of the number of people helped',
  text5tye: 'Actual Learning Situation',
  text5x5t: 'Get the list of popular cases and update the component status',
  text5xd7: 'Score After Learning',
  text5xd9: 'Views',
  text5xnm: 'Table',
  text60d9: 'Study Days',
  text62uf: 'Campus Usage',
  text64ws: 'Select Login Type',
  text6d5o: 'ImportDetails',
  text6fpu: 'After Publish',
  text6wd3: 'Progress Plan',
  text793f: 'Query Error',
  text7b65: 'Task Card Number',
  text7dyv: 'Switch Component Close Status',
  text7k6h: 'Unsubscribe',
  text7t2x: 'Login Type',
  text7tft: 'Intent Level',
  text7tmb: 'Source',
  text7xij: 'Test Report',
  text7y5k: 'Receive',
  text80zn: 'Downgrade',
  text825h: 'Client Phone Type',
  text85vb: 'School Case',
  text8ej2: 'Invitee',
  text8kwm: 'Please select the stage first',
  text8nto: 'Current Ranking',
  text925t: 'Import Result',
  text95jx: 'Then',
  text9e60: 'Way',
  text9et6: 'Cancel Publish Progress Case Permission',
  text9g4w: 'Send',
  text9qrf: 'Modify Progress Plan',
  text9y83: 'Helpful Number Details',
  texta8dx: 'More Options',
  textae2r: 'Export Current Details',
  textapni: 'Get Form Data',
  textaru3: 'Determine the final interface parameter name',
  textawcc: 'Login Parameters',
  textbayd: 'All',
  textbbau: 'Student Story',
  textbdya: 'WeChat Nickname',
  textbidw: 'Stage',
  textbj5w: 'Primary School',
  textbkhp: 'Voter Name',
  textbseu: 'Trial Course Report',
  textc5y4: 'Progress Effect',
  textch0r: 'Modify Academic Results',
  textcjnr: 'Or manually clear and click search',
  textczme: 'Mobile Phone',
  textdci8: 'My Favorites',
  textdcsw: 'Progress',
  textddaj: 'Here',
  textdds7: 'Recommended Student Name',
  textdffx: 'Cannot Write Randomly',
  textdif5: 'System Prompt',
  textdo4x: 'Attention',
  textdpjq: 'Connection Address',
  textdqe9: 'Correct Answer Rate',
  textdrns: 'Please EnterActivity Name',
  textds5q: 'Total Count',
  textdzp8: 'Learning Trajectory',
  texte50z: 'Get Form Data',
  texte96r: 'Clue Rules',
  texteed4: 'Collapse Options',
  textefu3: 'Get Form Data from Public Pool',
  texteklv: 'Case Display Information',
  textk19t: 'Please select a student and complete the case information first.',
  textccnj: 'Study days',
  hourlong: 'Weekly foundation study hours',
  smallhour: 'h',
  share: 'Share',
  textekyu: 'Foundation Building Retake',
  textelrk: 'Follow-up Person',
  texteltn: 'SearchUser',
  textf5t0: 'Middle School',
  textf9ue: 'New Version Tools',
  textfbrl: 'Please EnterUser',
  textfdf6: 'Textbook Version',
  textfed3: 'Learning Days',
  textfyvk: 'Page Views',
  textg8s8: 'Score Before Learning',
  textgnlu: 'Intelligent Adaptive Education',
  textgvft: 'Progress Score',
  textgz5r: 'Invited Person',
  texth2dc: 'Regular Course',
  texth39f: 'Source Management',
  texth5t6: 'Source',
  texthbj2: 'Please Enter',
  texthco4: 'Get Search Box Data',
  texthjji: 'Please go to Songguo',
  texthvm6: 'Foundation Building Upgrade',
  texthzx7: 'Total Count',
  texti3md: 'Logged-in Skill Group',
  texti3uw: 'Default Sorting',
  textibiy: 'Export Details',
  textidk9: 'Regular Course Retake',
  textif9n: 'Execute Search',
  textiu8r: 'Close Counter Popup',
  textiune: 'Existing',
  textj6ki: 'Get Form Data',
  textj8or: 'Form Data',
  textjw1n: 'Technology Changes Education',
  textjw4y: 'Backup Phone',
  textl0ql: 'Phone',
  textljf2: 'Old Version Tools',
  textlpqu: 'Class Hours',
  textltlk: 'Enter Knowledge Star',
  textlzrj: 'Error Reason',
  textm00g: 'Regular Course Report',
  textm2yt: 'Invitation Progress',
  textm590: 'Classmate',
  textm7oq: 'Current Votes',
  textm9t5: 'High School',
  textmpf2: 'Published Successfully',
  textmr1r: 'Export Image',
  textn2qz: 'Follow-upStatus',
  textn2wh: 'Score Progress',
  textn4j7: 'Unpublish Successful',
  textn7no: 'Review',
  textn7qn: 'File Name',
  textnbt3: 'Form Data',
  textngy8: 'Student Name',
  textni8p: 'Merchant Return/Exchange',
  textnkpc: 'Enrollment',
  textno2h: 'Get Phase and Subject Dictionary List and Update Component State',
  textnyic: 'Close Counter',
  texto188: 'Cannot Write Randomly',
  texto9j5: 'Import Component',
  texto9pn: 'Optional Fields',
  textof4b: 'Update Phase Filter Based on User Selection',
  textoh9j: 'Update Subject Filter Based on User Selection',
  textonft: 'Unsubscribe',
  textoryg: 'Will Determine Final Interface Parameter Name',
  textoz2b: 'Table Data',
  textozwa: 'Enrollment Score',
  textpd4r: 'Home Address',
  textpgqw: 'Number of Supporters',
  textpuh0: 'Course Learning Status',
  textpzrd: 'Classes Attended',
  textq1x0: 'Review',
  textq7fj: 'Progress Course Schedule',
  textqgox: 'Avatar',
  textqian: 'Unpublish',
  textqit9: 'Add Page View Tracking',
  textqjmj: 'Entry',
  textqmvx: 'Add Progress Case Permission',
  textr0p8: 'Edit Progress Case Permission',
  textrgur: 'Table Title',
  textrhrk: 'Edit',
  textrixp: 'Monitor Feature Usage',
  textrsdh: 'Soft Phone',
  textrx7n: 'Whether to Publish This Case',
  textrxnr: 'Top Return Function',
  texthkhr: 'New Recommendation',
  texts0fj: 'Student Referral',
  texts56p: 'Login',
  texts6a0: 'Number of Campuses Used',
  textsauw: 'Used',
  textsbo6: 'Total Questions',
  textschc: 'Loading Failed',
  textsdmg: 'All Set to Default',
  textsfjp: 'Provincial Hot List',
  textsgcw: 'Get Phase List',
  textsi66: 'Other',
  textsycd: 'Knowledge Star',
  textt3r7: 'Latest Release',
  textt612: 'Tag Management',
  textt6gm: 'Phase',
  texttghz: 'Switch Panel',
  texttkth: 'Will Determine Final Interface Parameter Name',
  texttxub: 'Otherwise All Should Be Default',
  textu1i9: 'Edit Student Story',
  textua16: 'Please select subject',
  textug0h: 'Whether to Unpublish This Case',
  textuj8v: 'Publish',
  textul9z: 'View Report Jump',
  textuve4: 'Attention',
  textv3l2: 'Download Poster',
  textvfnm: 'Number of Store Visits',
  textvjwj: 'Loading Failed',
  textvk04: 'Subject List',
  textvntq: 'Verification Info in Request Header etc',
  textvoqt: 'SearchUser',
  textw1de: 'Phase',
  textw94g: 'Please EnterActivity',
  textwaj4: 'Form Data',
  textwi6w: 'Page Update',
  textwmyx: 'Clue Name',
  textwuf3: 'Please Select Student First and Complete Case Information',
  textwvyp: 'Login Method',
  textx2bf: 'Trial Course Report',
  textx7ij: 'Student Score Information',
  textxrls: 'Logout',
  textxu12: 'Whether to Predict Outbound Call',
  textxvbk: 'Invalid Reason',
  textxxuo: 'Click Clear Button',
  texty201: 'If There Is',
  texty6pb: 'Favorites Count',
  textyad6: 'Add New Case',
  textygf8: 'Subject',
  textyiar: 'Referral Activity Details Export',
  textyl8q: 'Supporters Count Popup',
  textyr7v: 'Deal Count',
  textytgg: 'Unsubscribe',
  textz099: 'Unsubscribe',
  textz9y4: 'National Hot List',
  textzhl7: 'Ranking List',
  textzlms: 'Days of Improvement',
  textzqig: 'Publish Progress Case Permission',
  textzrxs: 'Gender',
  textzy8y: 'Voting User',
  time: 'Last Edit Time',
  titleBgPicLabel: 'Title Background:',
  to: 'to',
  todayClaimable: 'Claimable Today: ',
  totalCost: 'Total Cost',
  totalDataCount: 'Total Records',
  totalLeads: 'Total Leads',
  totalScoreLabel: 'Total score',
  totalUnits: 'Total Units: ',
  trainee: 'Trainee',
  transferApplySuccessTip: 'User {name} ({account}) has submitted transfer application. Please ask parent to confirm in Squirrel AI Parent App. If not confirmed within 7 days, transfer will fail.',
  transferFailed: 'Transfer failed',
  transferLead: 'Transfer Lead',
  transferLeadTip:
    'After transfer, the follow-up owner will update to the colleague you choose. Select the employee account to transfer to.',
  selectStaff: 'Select employee',
  pleaseSelectStaff: 'Please select an employee',
  onlyNormalStaffCanTransfer:
    'Only employees whose account status is "Normal" can receive a transfer.',
  transferShort: 'Transfer',
  transferToServiceCenter: 'Transfer to Service Center',
  trialStatusConverted: 'Converted',
  trialStatusExperiencing: 'In Trial',
  trialStatusExpired: 'Expired',
  trialStatusTerminated: 'Terminated',
  type: 'Type',
  followUpToday: 'To Follow Up Today',
  followUpOverdue: 'Overdue',
  followUpNotStarted: 'Not Started',
  followUpCompleted: 'Completed',
  followUpCancelled: 'Cancelled',
  unknownOrderStatus: 'Unknown order status',
  unmarkPrototype: 'Unmark Prototype',
  updateBtn: 'Update',
  updateCountTip: 'Counts updated existing leads only',
  updateImport: 'Update Import',
  updateImportTip: 'You are updating data in imported file 【{fileName}】. Any leads not yet uploaded will be uploaded with this operation.',
  updatedCount: 'Updated',
  uploadBeforeTip: 'Before upload, please',
  uploadDoc: 'Upload Document',
  uploadFail: 'Upload failed',
  uploadFailed: 'Upload failed. Token expired. Please refresh and retry.',
  uploadImage: 'Upload Image:',
  uploadMaterial: 'Upload Material',
  uploadStatusError: 'File upload status error',
  uploadSuccess: 'Upload successful',
  uploadTipSuffix: 'and follow the template to enter leads, otherwise import will fail',
  uploadVideo: 'Upload Video:',
  uploadVideoSize100MB: 'Video size must not exceed 100MB!',
  uploadVoucherImage: 'Upload voucher image',
  uploadVoucherTip: 'Only jpg/png, max 10MB, up to 6 images',
  uploading: 'Uploading...',
  useDeskPhoneOutcall: 'Use desk phone for outcall',
  usePhoneOutcall: 'Use phone for outcall',
  userNameLabel: 'User Name:',
  userProfile: 'User Profile',
  userProfileLabel: 'User Profile:',
  userProfileLabelForm: 'User Profile:',
  validateFailed: 'Validation failed. Please try again later.',
  validityDaysUnit: '{days} days ({date})',
  validityEndLabel: 'Valid Until:',
  validityPeriod: 'Validity Period',
  verifyCodeError: 'Verification code error',
  verifyCodeLabel: 'Verify Code:',
  verifyCodeRequired: 'Verification code is required',
  verifyCodeSendSuccess: 'Verification code sent successfully',
  verifyFail: 'Verify failed',
  verifyPhoneRequired: 'Phone must be verified before opening experience.',
  verifyPhoneTitle: 'Verify Phone',
  verifySuccess: 'Verify successful',
  video: 'Video',
  videoExceed20M: 'Video exceeds 20M. Please compress before uploading!',
  videoExceed50M: 'Video exceeds 50M. Please compress before uploading!',
  videoFormatMp4Avi: 'Video must be MP4/AVI format!',
  videoFormatTip: 'Supports mp4/AVI, max 50MB',
  videoMaterial: 'Video Material',
  videoSizeExceeded: 'Video size cannot exceed 300MB!',
  view: 'View',
  viewExamInfo: 'View Exam Info',
  viewFace: 'View Face',
  viewImage: 'View Image',
  viewInfo: 'View Info',
  viewProgress: 'View Progress',
  viewSchoolInfo: 'View School Info',
  visitStore: 'Visit Store:',
  visitStoreLabel: 'Visit Store: ',
  visitStoreLabelShort: 'Visit Store: ',
  visitTimeLabel: 'Visit Time: ',
  week: 'Statistics Period:',
  weekPromiseVisitLabel: 'Week Promise Visit: ',
  thisWeekPromisedVisit: 'This Week Promised Visit',
  whitelist: 'Whitelist',
  withdrawSuccess: 'Withdraw successful',
  wuyear: 'Grade 5',
  xue: 'Chemistry',
  xuexiao: 'School',
  year: 'Grade Level',
  yes: 'Yes',
  yi: 'Normalization Report',
  yiyear: 'Grade 1',
  yuanUnit: 'CNY',
  zhanghuyouqi: 'Account Validity',
  commonGrade: 'General',
  taskStatusCompleted: 'Completed',
  taskStatusNotStarted: 'Not Started',
  taskStatusOverdue: 'Overdue',
  taskStatusCancelled: 'Cancelled',
  followUpToday: 'To Follow Up Today',
  followUpOverdue: 'Overdue',
  followUpNotStarted: 'Not Started',
  followUpCompleted: 'Completed',
  followUpCancelled: 'Cancelled',
  pendingFollowUp: 'Pending Follow Up',
  calledPhone: 'Called',
  addedWeChat: 'Added WeChat',
  promisedVisit: 'Promised Visit',
  visited: 'Visited',
  dealDone: 'Deal Done',
  myLeadsRule: 'My Leads Rule',
  autoRecycleMechanism: 'Auto Recycle Mechanism',
  switchOn: 'On',
  switchOff: 'Off',
  autoRecycleTip: 'After enabled, you can set the system to automatically recycle leads that have not been followed up or converted for a certain number of days',
  daysNotFollowed: 'days not followed up',
  daysNotConverted: 'days not converted',
  day: 'days',
  pleaseEnterDays: 'Please enter days',
  leadPhoneDisplay: 'Lead Phone Display',
  leadPhoneDisplayTip: 'Selected personnel will be able to directly view and export the complete phone number of leads in the dealer system',
  publicPoolRule: 'Public Pool Rule',
  publicPoolSetting: 'Public Pool Settings',
  publicPoolEnableTip: 'After enabled, sales team members can see the public pool and claim leads from it',
  publicPoolDisableTip: 'After disabled, sales team members cannot see the public pool or claim leads, leads need to be assigned by admin',
  allocatedOver: 'Allocated over',
  autoRecycleDays: 'days, leads will be automatically recycled by the system upon expiration',
  intentionHigh: 'High',
  intentionMedium: 'Medium',
  intentionLow: 'Low',
  // ClueManagement additional keys
  followUpTodayQuick: 'To Follow Up Today',
  daysNotFollowedQuick: '7 Days Without Follow-up',
  daysNotConvertedQuick: '30 Days Without Conversion',
  pendingAllocateStatus: 'Pending Assign',
  pendingFollowStatus: 'Pending Follow',
  calledPhoneStatus: 'Called',
  addedWeChatStatus: 'Added WeChat',
  promisedVisitStatus: 'Promised Visit',
  visitedStatus: 'Visited',
  dealDoneStatus: 'Deal Done',
  calledPhoneOption: 'Called',
  addedWeChatOption: 'Added WeChat',
  promisedVisitOption: 'Promised Visit',
  visitedOption: 'Visited',
  dealDoneOption: 'Deal Done',
  customerNameColumn: 'Customer Name',
  mobileColumn: 'Mobile',
  followStatusColumnLabel: 'Follow Status',
  followPersonColumnLabel: 'Follow Person',
  smallClass: 'Pre-K Small',
  middleClass: 'Pre-K Middle',
  bigClass: 'Pre-K Big',
  grade1: 'Grade 1',
  grade2: 'Grade 2',
  grade3: 'Grade 3',
  grade4: 'Grade 4',
  grade5: 'Grade 5',
  grade6: 'Grade 6',
  grade7: 'Grade 7',
  grade8: 'Grade 8',
  grade9: 'Grade 9',
  senior1: 'Senior 1',
  senior2: 'Senior 2',
  senior3: 'Senior 3',
  senior4: 'Senior 4',
  commonGradeOption: 'General',
  inviteKnowledgeGapExam: 'Invite Knowledge Gap Exam',
  inviteBy: 'Inviter',
  knowledgeGapBigExperience: 'Knowledge Gap Big Experience',
  inviteTime: 'Invite Time',
  appointmentVisitTime: 'Appointment Visit Time',
  visitStatus: 'Visit Status',
  visitTime: 'Visit Time',
  inviter: 'Inviter',
  experienceStatus: 'Experience Status',
  courseSubject: 'Course Subject',
  subject: 'Subject',
  version: 'Version',
  testDuration: 'Test Duration',
  unit: 'Unit',
  knowledgePointMasteryRate: 'Knowledge Point Mastery Rate',
  testTime: 'Test Time',
  nameLabelColumn: 'Name',
  stageGradeColumn: 'Stage/Grade',
  learningCenterAccountColumn: 'Learning Center Account',
  analystPersonColumn: 'Analyst',
  allLeadsTab: '"All Leads"',
  allLeadsTabDesc: ' is used for store management staff to manage, assign, and view leads',
  myLeadsTab: '"My Leads"',
  myLeadsTabDesc: ' is used for sales management and viewing leads',
  publicPoolTab: 'Public Pool for managing unassigned leads',
  recycleBinTab:
    'Recycle Bin is for viewing and managing leads marked as invalid',
  pleaseEnterMobile: 'Please enter mobile number',
  batchRecallAction: 'Batch Recall',
  batchReleaseAction: 'Batch Release',
  batchRestoreAction: 'Batch Restore',
  // ClueManagement config.js labelKeys
  tag1: 'Tag',
  source2: 'Source',
  operationMode3: 'Operation Mode',
  tag4: 'Tag',
  source5: 'Source',
  operationMode6: 'Operation Mode',
  source7: 'Source',
  tag8: 'Tag',
  operationMode9: 'Operation Mode',
  source10: 'Source',
  marker11: 'Marker',
  invalidReason12: 'Invalid Reason',
  intentLevel13: 'Intent Level',
  source14: 'Source',
  tag15: 'Tag',
  operationMode16: 'Operation Mode',
  intentLevel17: 'Intent Level',
  tag18: 'Tag',
  source19: 'Source',
  operationMode20: 'Operation Mode',
  source21: 'Source',
  tag22: 'Tag',
  source23: 'Source',
  tag24: 'Tag',
  marker25: 'Marker',
  markedInvalidReason26: 'Invalid Reason Marked',
  // ClueManagement/config.js only (do not reuse generic time/name/mobile keys)
  clueMgmt_ph_leadNameOrPhone: 'Enter lead name or mobile number',
  clueMgmt_ph_selectThisWeekVisit: 'Select this week promised visit',
  clueMgmt_ph_selectCreator: 'Select creator',
  clueMgmt_ph_selectMarker: 'Select marker',
  clueMgmt_lastAssignTime: 'Last assignment time',
  clueMgmt_lastFollowPerson: 'Last follow-up person',
  clueMgmt_lastFollowRecord: 'Last follow-up record',
  clueMgmt_invalidTime: 'Invalid time',
  clueMgmt_markInvalidTime: 'Marked invalid time',
  clueMgmt_gradeOnly: 'Grade',
  clueMgmt_mobileNumber: 'Mobile number',
  clueMgmt_nextFollowTime: 'Next follow-up time',
  followStatus: 'Follow Status',
  follower: 'Follower',
  claimTime: 'Claim Time',
  homeworkDetail: 'Homework Details',
  // ReferralActivities config.js
  activity: 'Activity',
  enterActivity: 'Enter Activity',
  enterActivityName: 'Enter Activity Name',
  phone: 'Phone Number',
  enterPhone: 'Enter Phone Number',
  inviterWxNickname: 'Inviter WeChat Nickname',
  inviterWxAvatar: 'Inviter WeChat Avatar',
  inviteeWxNickname: 'Invitee WeChat Nickname',
  inviteeWxAvatar: 'Invitee WeChat Avatar',
  inviteePhone: 'Invitee Phone Number',
  inviteProgress: 'Invite Progress',
  invitationTime: 'Invite Time',
  retentionTime: 'Retention Time',
  queryBtn: 'Query',
  resetBtn: 'Reset',
  auto_932: 'Enable outbound-call presale discount',
  auto_933: 'Presale discount price',
  auto_406934: 'Original price ¥406',
  auto_935: '* Outbound technology by ',
  auto_936: 'the same vendor as Zuoyebang and Yuanfudao',
  auto_937: '* Covers number resources of the three major carriers nationwide',
  auto_938: 'Three-carrier number resources nationwide',
  auto_939: '* The system assigns and displays a local caller ID; ',
  auto_940: 'no need to prepare your own numbers',
  auto_941: 'helps with number tagging and blocking issues',
  auto_942: '* New activation ',
  auto_943: 'requires a one-time setup fee; renewals are not charged again',
  auto_944: '* Billed monthly, ',
  auto_945: 'unlimited users',
  auto_946: 'Setup fee: ',
  auto_947: 'Limited-time 90% off, original price CNY 288.00',
  auto_948: 'Package fee: ',
  auto_949: 'Unlimited users, 500 free minutes included, CNY 0.12/min beyond',
  auto_950: 'Activation period (months): ',
  auto_951: 'Presale: up to 12 months',
  auto_989: 'Please read and accept the outbound service ',
  auto_990: 'activation agreement',
  auto_954: 'Total: ',
  auto_992: 'Pay',
  auto_958: 'This payment will deduct:',
  auto_959: 'Confirm order cancellation? Paid amounts will be refunded to',
  auto_960: 'the corresponding agent accounts and related futures order limits will be adjusted.',
  auto_1003: 'Payment settings',
  auto_1004: 'Auto-renewal',
  auto_962: 'When auto-renewal is on, after expiry the service renews at CNY 170/month by default, deducted from the cash account.',
  auto_1005: 'Top up call credit',
  auto_1006: 'Current balance: ',
  auto_1007: 'Top-up amount: ',
  auto_1008: 'Enter a number',
  auto_964: ' (CNY 0.12 per minute)',
  auto_1009: 'To pay: ',
  auto_980: 'Please read and accept the outbound service ',
  auto_981: 'activation agreement',
  auto_983: 'Pay',
  auto_1015: 'Activate outbound service',
  auto_1011: 'Setup fee:',
  auto_969: 'Limited-time 90% off',
  auto_970: ' (original CNY 288)',
  auto_1016: 'Package fee:',
  auto_984: '(Unlimited users, 500 free minutes, CNY 0.12/min beyond)',
  auto_1017: 'Months:',
  auto_1018: 'Total to pay:',
  auto_985: 'Auto-renew when expired',
  auto_973: '① After payment, HQ will complete onboarding and activation within ',
  auto_974: '7–10 business days',
  auto_975: '. In some regions numbers are scarce and activation may take longer. Please follow order status in Dealer System → Outbound → Cost management.',
  auto_17976: '② To avoid disrupting your outbound work, for the months you selected it will auto-renew at CNY 170/month after expiry, charged from the cash account by default; ',
  auto_987: 'you can turn this off anytime.',
  auto_978: '③ Flexible use; ',
  auto_979: 'refunds supported.',
  auto_965: 'Please read and accept the outbound service ',
  auto_966: 'activation agreement',
  auto_968: 'Pay',
  auto_1010: 'Activate outbound service',
  auto_1012: 'Package fee:',
  auto_971: '(Unlimited users, 500 free minutes, CNY 0.12/min beyond)',
  auto_1013: 'Months:',
  auto_1014: 'Total to pay:',
  auto_972: 'Auto-renew when expired',
  auto_17986: '① To avoid disrupting your outbound work, for the months you selected it will auto-renew at CNY 170/month after expiry, charged from the cash account by default; ',
  auto_977: 'you can turn this off anytime.',
  auto_988: '③ Flexible use; refunds supported.',
  auto_952: 'Please read and accept the outbound service ',
  auto_953: 'activation agreement',
  auto_956: 'Pay',
  auto_993: 'Your outbound service is active. To avoid paying the setup fee again, please renew via ',
  auto_994: 'Dealer System → Outbound → Cost management → “Renew”',
  auto_995: '. For questions, contact Squirrel AI support first.',
  auto_996: 'Your outbound service is being activated and should complete within about 7 business days. Please do not place duplicate orders. For questions, contact Squirrel AI support first.',
  auto_998: 'You have not activated outbound service yet. Please use ',
  auto_999: 'Dealer System → Outbound → Cost management → “Activate service”',
  auto_1000: ' to pay and activate. For questions, contact Squirrel AI support first.',
  auto_1001: 'Your outbound service is being activated and should complete within about 7 business days. Please do not renew repeatedly. For questions, contact Squirrel AI support first.',
  auto_603: 'Enabled successfully',
  auto_604: 'Disabled successfully',
  auto_605: 'servicefailed',
  auto_606: 'Payment Success',
  auto_607: 'Payment Failed',
  auto_591: 'Micro Flyer',
  auto_592: 'Create activity',
  auto_593: 'Daily Image',
  auto_594: 'View image',
  auto_595: 'View video',
  auto_596: 'Micro Flyer',
  auto_806: 'Activity operation rules',
  auto_807: 'I have read and understood the Advertising Law and commit to strict compliance.',
  auto_808: 'Advertising law wording guide',
  auto_2809: '19941027199521',
  auto_24810: '20154',
  auto_811: 'General provisions',
  auto_812: 'Article 1',
  auto_813: 'Article 2',
  auto_814: 'Article 3',
  auto_815: 'Article 4',
  auto_816: 'Article 5',
  auto_817: 'Article 6',
  auto_818: 'Article 7',
  auto_819: 'advertising',
  auto_820: 'Article 8',
  auto_821: 'advertisingservice',
  auto_822: 'Items that must be disclosed by law in advertisements should be shown prominently and clearly.',
  auto_823: 'Article 9',
  auto_824: '1) Using or disguising use of PRC flags, anthem, emblem, military flag, military anthem, or military emblem.',
  auto_825: 'Content',
  auto_826: 'Content',
  auto_827: 'Content',
  auto_828: 'Content',
  auto_829: 'Private',
  auto_830: 'Content',
  auto_831: 'Content',
  auto_832: 'Content',
  auto_833: 'Content',
  auto_834: 'lawlaw',
  auto_835: 'Article 10',
  auto_836: 'Article 11',
  auto_837: 'advertising',
  auto_838: 'advertisingdata',
  auto_839: 'Article 12',
  auto_840: 'advertisinglaw',
  auto_841: 'advertising',
  auto_842: 'Article 13',
  auto_843: 'Advertisements must not disparage other operators, products, or services.',
  auto_844: 'Article 24',
  auto_845: '1) No guaranteed promises about admissions, exam pass rates, certificates, or training outcomes.',
  auto_846: 'Content',
  auto_847: 'Content',
  auto_848: 'Article 25',
  auto_849: 'Content',
  auto_850: 'Content',
  auto_851: 'Content',
  auto_852: 'Content',
  auto_853: 'Article 28',
  auto_854: 'service',
  auto_855: 'Content',
  auto_856: 'law',
  auto_857: 'service',
  auto_858: '5) Other cases that deceive or mislead consumers with false or confusing content.',
  auto_859: 'Article 33',
  auto_860: 'Article 38',
  auto_861: 'service',
  auto_862: 'advertisinglaw',
  auto_863: 'Article 39',
  auto_864: 'Article 40',
  auto_865: 'advertisingservice',
  auto_866: 'Content',
  auto_867: 'Article 44',
  auto_868: 'Content',
  auto_869: 'Legal liability',
  auto_870: 'Article 55',
  auto_871: 'advertising',
  auto_872: 'advertisinglaw',
  auto_873: 'lawadvertising',
  auto_874: 'advertisinglaw',
  auto_875: 'advertisingadvertising',
  auto_876: 'advertisingadvertisingadvertisingPublish',
  auto_877: 'law',
  auto_878: 'Article 56',
  auto_879: 'servicelawadvertising',
  auto_880: 'serviceadvertising',
  auto_881: 'Article 57',
  auto_882: 'Content',
  auto_883: 'advertisingadvertisingPublishadvertising',
  auto_884: 'Publishlawadvertising',
  auto_885: 'Chemistry',
  auto_886: 'lawPublish',
  auto_887: 'lawPublishadvertising',
  auto_888: 'lawadvertising',
  auto_889: 'law',
  auto_890: 'Article 58',
  auto_891: 'advertisingadvertisinglaw',
  auto_892: 'lawPublishadvertising',
  auto_893: 'lawadvertising',
  auto_894: 'lawPublishadvertising',
  auto_895: 'lawPublishadvertising',
  auto_896: 'lawPublishadvertising',
  auto_897: 'lawPublishadvertising',
  auto_898: 'lawPublish',
  auto_899: 'lawPublishadvertising',
  auto_900: 'lawPublish',
  auto_901: 'law',
  auto_902: 'lawlaw',
  auto_903: 'Primary schoolPrimary school',
  auto_904: 'lawPublish',
  auto_905: 'lawPublishadvertising',
  auto_906: 'Prohibited words',
  auto_907: 'Content',
  auto_908: 'Content',
  auto_909: 'Content',
  auto_910: 'NO1TOP',
  auto_911: 'Content',
  auto_912: 'Content',
  auto_913: 'Content',
  auto_914: 'XX',
  auto_915: 'Content',
  auto_916: 'Content',
  auto_917: 'Content',
  auto_918: '100',
  auto_919: 'Content',
  auto_920: 'Content',
  auto_921: 'Content',
  auto_922: 'Content',
  auto_923: 'Content',
  auto_924: 'XX',
  auto_925: 'time',
  auto_926: 'time',
  auto_929: 'Create activity',
  auto_597: 'Scan with WeChat to preview',
  auto_598: 'Micro Flyer',
  auto_599: 'Daily Image',
  auto_600: 'Micro Video',
  auto_601: 'Daily Image',
  auto_602: 'Micro Video',
  auto_638: 'Score Progress',
  auto_639: 'Total subject score',
  auto_640: 'Please enter a 3-digit positive integer',
  auto_641: 'Entrance Score',
  auto_644: '3',
  auto_643: 'Completion score',
  auto_642: '3',
  auto_608: 'Add student story',
  auto_645: 'Edit student story',
  auto_646: 'Learning statusStatusA',
  auto_647: 'Upload Image',
  auto_609: 'Save information',
  auto_610: 'Learning status',
  auto_611: 'Total Study Duration',
  auto_636: 'Label',
  auto_613: 'Cumulative days',
  auto_614: 'Total questions answered',
  auto_615: 'Content',
  auto_616: 'Label',
  auto_617: 'Content',
  auto_618: 'Growth record',
  auto_619: 'Time',
  auto_620: 'Content',
  auto_621: 'Content',
  auto_622: 'Content',
  auto_623: 'Target learning duration',
  auto_624: 'Improvement plan',
  auto_625: 'Add Menu Information',
  auto_626: 'Edit Menu Information',
  auto_627: 'Menu Sort',
  auto_628: 'Menu Name',
  auto_629: 'Create Time',
  auto_630: 'Create By',
  auto_631: 'Learning trajectory',
  auto_633: 'View Report',
  auto_634: 'Consult improvement plan now',
  auto_474: 'Final score',
  auto_477: 'Enabled successfully',
  auto_478: 'Today Invite Knowledge Hole Big Physical Examination',
  auto_479: 'Invite',
  auto_480: 'Content',
  auto_481: 'Label',
  auto_482: 'Content',
  auto_483: 'Content',
  auto_484: 'Content',
  auto_485: 'Operation',
  auto_486: 'Content',
  auto_487: 'Label',
  auto_488: 'Label',
  auto_489: 'Report List',
  auto_490: 'Label',
  auto_491: 'Label',
  auto_492: 'Label',
  auto_493: 'Label',
  auto_494: 'Label',
  auto_495: 'Enabled successfully',
  auto_496: 'Disabled successfully',
  auto_497: 'Enabled successfully',
  auto_498: 'Disabled successfully',
  auto_499: 'Enabled successfully',
  auto_500: 'In progress',
  auto_649: 'Select student',
  auto_650: 'Case settings',
  auto_665: 'Case title',
  auto_666: 'Math9035',
  auto_667: 'Learning Subject',
  auto_669: 'Study period',
  auto_520: 'Select studentStudy period',
  auto_670: 'Entry grade',
  auto_651: 'Student basic info',
  auto_671: 'Student Name',
  auto_672: 'Student phone',
  auto_673: 'Learning machine account',
  auto_674: 'Student type',
  auto_675: 'Homeroom teacher',
  auto_676: 'Owner',
  auto_677: 'Campus',
  auto_652: 'Share settings',
  auto_678: 'Share poster',
  auto_653: 'Top Student Challenge',
  auto_654: 'Please select a poster template',
  auto_679: 'Lead form settings',
  auto_680: 'Phone Number',
  auto_655: 'Save draft',
  auto_656: 'Save and publish',
  auto_683: 'Score',
  auto_657: 'Score',
  auto_685: 'Exam Type',
  auto_686: 'Exam date',
  auto_687: 'Score',
  auto_658: 'Score',
  auto_688: 'Score',
  auto_689: 'Subject',
  auto_690: 'Select subject',
  auto_691: 'Exam Type',
  auto_692: 'Select exam type',
  auto_693: 'Exam date',
  auto_694: 'Select exam date',
  auto_695: 'Full score',
  auto_696: 'Enter full marks',
  auto_697: 'Score',
  auto_698: 'Enter score',
  auto_699: 'Class rank',
  auto_700: 'Class ranking',
  auto_701: 'Grade rank',
  auto_702: 'Grade ranking',
  auto_705: 'Exam paper photo',
  auto_706: 'Improvement plan',
  auto_659: 'Progress Course Schedule',
  auto_707: 'Number of classes',
  auto_708: 'Enter class count',
  auto_660: 'Class Hours',
  auto_709: 'Class frequency',
  auto_711: 'Enter class frequency',
  auto_710: 'Enter class frequency',
  auto_661: 'Content',
  auto_712: 'Weekly foundation study hours',
  auto_713: 'Enter weekly foundation hours',
  auto_662: 'Label',
  auto_714: 'Content',
  auto_663: 'Top Student Challenge',
  auto_521: 'case',
  auto_522: 'Primary School',
  auto_530: 'Junior High',
  auto_536: 'Senior High',
  auto_540: 'Grade 13',
  auto_542: 'Phone Number',
  auto_545: 'Top Student Challenge',
  auto_546: 'Edit case',
  auto_560: 'User Details',
  auto_578: 'Select student',
  auto_579: 'Student name',
  auto_561: 'Student basic info',
  auto_562: 'Student Name',
  auto_564: 'Area',
  auto_567: 'Service Center',
  auto_568: 'casesettings',
  auto_580: 'Case title',
  auto_581: 'Subject',
  auto_582: 'Math',
  auto_583: 'English',
  auto_584: 'Chinese',
  auto_585: 'Physics',
  auto_586: 'Chemistry',
  auto_587: 'Biology',
  auto_588: 'Geography',
  auto_589: 'Science',
  auto_590: 'Study period',
  auto_569: '180',
  auto_570: 'chooseStagevalplaceholder',
  auto_571: 'Sharing settings',
  auto_572: 'Private',
  auto_573: 'Public',
  auto_574: 'Gold coins',
  auto_575: '5050',
  auto_576: 'Save preview case',
  auto_577: 'Save and exit',
  auto_432: 'Phone Number',
  auto_435: 'Age',
  auto_436: 'School',
  auto_437: 'Primary School',
  auto_444: 'Junior High',
  auto_448: 'Senior High',
  auto_452: 'Primary School',
  auto_459: 'Junior High',
  auto_464: 'Senior High',
  auto_468: 'Grade 13',
  auto_469: 'Content',
  auto_359: 'Device SN Code',
  auto_360: 'Operation',
  auto_353: 'Phone Rebind',
  auto_354: 'Logistics Detail',
  auto_361: 'Account Phone Rebind',
  auto_362: 'Machine Account Code',
  auto_363: 'Learning Machine Account',
  auto_364: 'Agent ID',
  auto_365: 'Agent Name',
  auto_366: 'Original Phone',
  auto_367: 'Enter original phone number',
  auto_372: 'Verification Code',
  auto_369: 'Please enter verification code',
  auto_262: 'Send Code',
  auto_263: 'Resend',
  auto_370: 'New Phone',
  auto_371: 'Enter new phone number',
  auto_368: 'Verification Code',
  auto_373: 'Please enter verification code',
  auto_264: 'Send Code',
  auto_265: 'Resend',
  auto_356: 'Next',
  auto_374: 'Logistics Detail',
  auto_375: 'Company Name',
  auto_377: 'Express No.',
  auto_358: 'Latest',
  auto_378: 'Study Machine Remark',
  auto_380: 'Enter content',
  auto_266: 'Product Name',
  auto_267: 'Agent',
  auto_268: 'Agent Name',
  auto_269: 'Account Status',
  auto_270: 'Device Status',
  auto_271: 'Device Activate Time',
  auto_272: 'Account Activate Time',
  auto_273: 'Dispatch Date',
  auto_274: 'Courier company',
  auto_275: 'Express No.',
  auto_276: 'Logistics Status',
  pleaseEnterExpressCompany: 'Please enter courier company',
  pleaseEnterExpressNo: 'Please enter express no.',
  pleaseSelectLogisticsStatus: 'Please select logistics status',
  auto_277: 'Assigned counter',
  auto_278: 'Counter assignment time',
  counterEquipmentSearchSnLabel: 'Device SN:',
  counterEquipmentSearchSnPlaceholder: 'Enter device SN',
  counterEquipmentSearchProductNameLabel: 'Product name',
  counterEquipmentSearchProductNamePlaceholder: 'Enter product name',
  counterEquipmentSearchAgentLabel: 'Agent',
  counterEquipmentSearchCounterAssignTimeLabel: 'Counter assignment time',
  auto_280: 'Not Activated',
  auto_281: 'Activated',
  auto_282: 'Freeze',
  auto_283: 'Subscribed',
  auto_382: 'Counter Type',
  auto_383: 'Counter No.',
  auto_384: 'Status',
  auto_284: 'Pending Review',
  auto_385: 'Counter Manager',
  auto_386: 'Enter counter manager name',
  auto_387: 'Manager Phone',
  auto_388: 'Please enter',
  auto_389: 'Province/City',
  auto_390: 'Counter Address',
  auto_391: 'Content',
  auto_392: 'Apply Remark',
  auto_393: 'Please fill in apply remark',
  auto_394: 'Counter photo',
  auto_381: 'Contract agreement',
  auto_395: 'Attachment',
  auto_396: 'Operation',
  auto_397: 'Confirm Result',
  auto_398: 'Please select confirm result',
  auto_399: 'Confirm Remark',
  auto_400: 'Enter remark',
  auto_401: 'Addxie yi',
  auto_402: 'File Type',
  auto_403: 'Content',
  auto_404: 'Lease agreement',
  auto_405: 'Supplementary agreement',
  auto_406: 'Other agreement',
  auto_407: 'Signing time',
  auto_409: 'Validity Period',
  auto_410: 'Attachment',
  auto_412: 'Enter remark',
  auto_287: 'File Type',
  auto_288: 'Signing time',
  auto_289: 'Validity Period',
  auto_291: 'Create Time',
  auto_292: 'Creator',
  auto_293: 'LatestUpdate Time',
  auto_294: 'Pending Review',
  auto_295: 'Lease agreement',
  auto_296: 'Supplementary agreement',
  auto_297: 'Other agreement',
  auto_298: 'Attachment',
  auto_762: 'Activity Rules',
  auto_763: 'Activity status',
  auto_755: 'Paused',
  auto_764: 'Initiators',
  auto_765: 'Number of Supporters',
  auto_766: 'Average helpers per user',
  auto_767: 'Number of Store Visits',
  auto_768: 'Conversion Rate',
  auto_769: 'Operation',
  auto_756: 'Download Poster',
  auto_770: 'Create activity',
  auto_771: 'Activity Name',
  auto_772: 'Enter activity name',
  auto_773: 'Activity time',
  auto_774: 'Activity Rules',
  auto_775: 'Content',
  auto_757: 'Quantity',
  auto_776: 'Content',
  auto_758: '2888Mobile number',
  auto_777: 'Content',
  auto_759: '4',
  auto_778: 'Content',
  auto_760: 'Contact',
  auto_779: 'user',
  auto_780: 'Download QR code',
  auto_781: 'Download Poster',
  auto_761: 'Scan to claim benefits',
  auto_208: 'Mark Invalid',
  auto_209: 'Data Migration',
  auto_210: 'Content',
  auto_230: 'Affiliated agent',
  auto_231: 'Next Follow Time',
  auto_238: 'Enter student name',
  auto_242: 'Select birth date',
  auto_1244: 'Family member',
  auto_2246: 'Family member',
  auto_250: 'Add Follow Record',
  auto_251: 'Follow-up type',
  auto_252: 'Select follow type',
  auto_254: 'Please enter',
  auto_255: 'Follow Voucher',
  auto_256: 'Next Follow Time',
  auto_257: 'Select next follow time',
  auto_258: 'Invite Big Exam',
  auto_219: 'Mobile number',
  auto_220: 'Mobile number',
  auto_221: 'Send Code',
  auto_222: 'Next',
  auto_223: 'Validity Period',
  auto_224: 'Account',
  auto_227: 'Copy',
  auto_225: 'Copy',
  auto_211: 'time',
  auto_212: 'Select stage/grade',
  auto_237: 'Grade 13',
  auto_239: 'Import',
  auto_414: 'sNma',
  auto_415: 'Please enter SN code',
  auto_416: 'Content',
  auto_417: 'Status',
  auto_418: 'Report Active Location',
  auto_419: 'Dealer Location',
  auto_420: 'Report By',
  auto_421: 'Agent',
  auto_422: 'Agent',
  auto_423: 'Superior Agent',
  auto_424: 'Report Time',
  auto_425: 'Content',
  auto_426: 'Software Activate Status',
  auto_427: 'Review Result',
  auto_428: 'Pay',
  auto_413: '5PDF',
  auto_299: 'File',
  auto_429: 'Report Reason',
  auto_430: 'Enter report reason',
  auto_300: 'Operate Time',
  auto_301: 'Operator',
  auto_302: 'Status',
  auto_303: 'Account',
  auto_305: 'Content',
  auto_306: 'Copy',
  auto_307: 'Content',
  auto_308: 'Add Report',
  auto_309: 'Content',
  auto_310: 'Report Again',
  auto_311: 'Saved successfully',
  auto_312: 'Save failed',
  auto_313: 'upload',
  auto_314: 'Content',
  auto_733: 'Activity ID',
  auto_744: 'Activity Name',
  auto_746: 'Activity Rules',
  auto_736: 'Activity status',
  auto_737: 'activity',
  auto_738: 'Initiators',
  auto_739: 'Content',
  auto_740: 'Content',
  auto_741: 'Deal Count',
  auto_742: 'Operation',
  auto_732: 'Download QR code',
  auto_743: 'Activity Rules',
  auto_734: 'Activity Name',
  auto_745: 'Activity time',
  auto_735: 'Activity Rules',
  auto_747: 'activity',
  auto_748: 'activity',
  auto_749: 'No.',
  auto_750: 'reason',
  auto_751: 'Content',
  auto_752: 'Contact',
  auto_753: 'time',
  auto_754: 'Download QR code',
  auto_722: 'Title',
  auto_723: 'Status',
  auto_724: 'Review Status',
  auto_725: 'Operation',
  auto_547: 'Off Shelf',
  auto_548: 'Publish',
  auto_717: 'Content',
  auto_549: 'Off Shelf',
  auto_550: 'Publish',
  auto_726: 'Content',
  auto_727: 'casename',
  auto_728: 'ID',
  auto_729: 'Publishname',
  auto_730: 'Content',
  auto_719: 'Content',
  auto_720: 'Content',
  auto_731: 'time',
  auto_721: 'ClosePreview',
  auto_553: 'Published',
  auto_554: 'Publish',
  auto_555: 'Unpublish',
  auto_556: 'Content',
  auto_557: 'Passed',
  auto_558: 'Disable',
  auto_559: 'Pending Review',
  auto_330: 'Select appointment time',
  auto_331: 'time',
  auto_333: 'Phone Number',
  auto_334: 'Invite Time',
  auto_335: 'Account',
  auto_336: 'Test Time',
  auto_338: 'Test Status',
  auto_342: 'Subject',
  auto_343: 'Version',
  auto_344: 'Test Duration',
  auto_345: 'Unit',
  auto_346: 'Knowledge Point Mastery Rate',
  auto_347: 'Test Time',
  auto_290: 'Data Migration',
  auto_279: '1AgentAgent',
  auto_285: 'Content',
  auto_194: 'Connection Address',
  auto_195: 'Content',
  auto_196: 'sIP',
  auto_203: 'Login',
  auto_204: 'Logout',
  auto_205: 'Login',
  auto_206: 'Logout',
  auto_0197: 'Mobile Phone',
  auto_1198: 'sIP',
  auto_2199: 'webCallWebRtc',
  auto_200: 'Login Method',
  auto_201: 'Content',
  auto_1204: 'Default',
  auto_1202: 'Default',
  auto_207: '103csqy',
  auto_782: 'Content',
  auto_801: 'Select student',
  auto_802: 'Student name',
  auto_783: 'Student basic info',
  auto_784: 'Student Name',
  auto_786: 'Area',
  auto_789: 'Service Center',
  auto_803: 'Content',
  auto_4790: 'MP',
  auto_791: '1560',
  auto_792: '100M',
  auto_804: 'Content',
  auto_793: 'Preview',
  auto_794: 'details',
  auto_795: 'Select student',
  auto_796: 'upload',
  auto_797: 'Content',
  auto_798: 'upload',
  auto_800: 'Content',
  auto_1021: 'Content',
  auto_1027: 'Operation',
  auto_1028: 'Category Name',
  auto_1029: 'name',
  auto_1030: 'Content',
  auto_1031: 'Private',
  auto_1033: 'Content',
  auto_1026: 'Create Now',
  auto_632: 'Content',
  auto_635: 'Content',
  auto_501: 'Remaining experience credit for this month',
  auto_514: 'Operation',
  auto_502: 'more options',
  auto_503: 'Invite Again',
  auto_504: 'Confirm Experience',
  auto_506: 'Open Entry Account',
  auto_508: 'Copy',
  auto_507: 'Copy',
  auto_529: 'Select experience analyst',
  auto_511: 'Confirmuser',
  auto_513: 'Canceluser',
  auto_534: 'activity',
  auto_535: 'Content',
  auto_539: 'Select sub tag',
  auto_20531: 'jpgpng1080x1920',
  auto_348: 'Type',
  auto_349: 'Status',
  auto_350: 'Operation',
  auto_351: 'reasonname',
  auto_352: 'Please enter invalid reason',
  auto_248: 'Operation successful',
  auto_249: 'Operation successful',
  auto_253: 'reason',
  auto_1041: 'name',
  auto_1039: 'Status',
  auto_1040: 'Operation',
  auto_1038: 'name',
  auto_1042: 'Enter tag name',
  auto_259: 'Operation successful',
  auto_260: 'Content',
  auto_261: 'Please entername',
  auto_321: 'name',
  auto_318: 'Type',
  auto_319: 'Status',
  auto_320: 'Operation',
  auto_317: 'name',
  auto_322: 'Enter source name',
  auto_241: 'Content',
  auto_245: 'Content',
  auto_246: 'Please entername',
  auto_1043: 'A',
  auto_1044: 'A',
  auto_1045: 'B',
  auto_1046: 'B',
  auto_1047: 'BMobile number',
  auto_1048: 'Invitation Progress',
  auto_1049: 'Invite Time',
  auto_1050: 'time',
  auto_1059: 'Service Center Name',
  auto_1060: 'Detail Address',
  auto_1061: 'Content',
  auto_1062: '50500',
  auto_1063: 'Content',
  auto_1064: 'Contact',
  auto_1065: 'Contact',
  auto_1066: 'QR code',
  auto_505: 'Content',
  auto_1084: 'Content',
  auto_1085: 'Ai',
  auto_512: 'Foundation downgrade',
  auto_515: 'Foundation upgrade',
  auto_516: 'Foundation retake',
  auto_1052: 'Review Status',
  auto_1053: 'Content',
  auto_1054: 'Current Ranking',
  auto_1055: 'Operation',
  auto_1056: 'reason',
  auto_1051: 'Review',
  auto_1072: 'Import',
  auto_1073: 'Import Query',
  auto_1074: 'downloaddataupload',
  // PotentialCustomers/components/uploadProgress.vue (auto_651/652 are used elsewhere)
  potentialImportCompleteTip: 'Import finished. Tap to view',
  potentialImportQueryLink: 'Import query',
  potentialImportReuploadBtn: 'Download data again and return to upload',
  potentialImportRunningTip:
    'Importing. If you close this page by mistake, check progress under Import query.',
  potentialImportFailureTip:
    'Import was interrupted. Some rows failed. Download the data again and re-upload.',
  auto_304: 'Copy',
  auto_1088: 'Activate account',
  auto_1067: 'Operation Reminder',
  auto_1068: 'After invalidation, the lead will be marked as invalid and removed from the lead list. Continue?',
  auto_1070: 'Invalid Reason',
  auto_1071: 'Within 100 characters',
  auto_325: 'Info does not exist',
  auto_326: 'Grant failed',
  auto_327: 'law',
  auto_329: 'System error',
  auto_470: 'Publishcase',
  auto_471: 'CancelPublishcase',
  auto_472: 'Published successfully',
  auto_473: 'Cancel publish successful',
  auto_1075: 'Gift Claim Status',
  auto_1076: 'Operation',
  auto_1089: 'Enable outbound-call presale discount',
  auto_648: 'Payment Success',
  auto_1082: 'Copy Link',
  auto_1083: 'Download QR code',
  craaOperation: 'Operation',
  craaViewDetail: 'View Details',
  craaResubmit: 'Resubmit',
  craaQueryFailed: 'Query failed',
  craaOnlyRejectedCanResubmit: 'Only rejected appeals can be resubmitted',
  craaAlreadyReportedNoNeedSubmit: 'This device has already been reported. No need to submit.',
  craaPendingReviewNoRepeatSubmit: 'This device already has a pending review request. Do not submit again.',
  craaInObservationNoRepeatSubmit: 'This device is currently in observation period. Do not submit again.',
  craaNoNeedSubmit: 'This device does not require submission.',
  craaCheckResubmitStatusFailed: 'Failed to check resubmission status',
  craaDeviceSnCode: 'Device SN Code',
  craaPleaseEnterDeviceSnCode: 'Please enter device SN code',
  craaAppealStatus: 'Appeal Status',
  craaPleaseSelectAppealStatus: 'Please select appeal status',
  craaPendingReview: 'Pending Review',
  craaReviewApproved: 'Approved',
  craaReviewRejected: 'Rejected',
  craaAppealTime: 'Appeal Time',
  craaPleaseSelectAppealSubmitTime: 'Please select appeal submission time',
  craaDeviceModel: 'Device Model',
  craaDealerId: 'Dealer ID',
  craaDealerName: 'Dealer Name',
  craaDealerLocation: 'Dealer Location',
  craaSoftwareActivationTime: 'Software Activation Time',
  craaSoftwareActivationProvinceCity: 'Software Activation Province/City',
  craaCrossRegionActiveDate: 'Cross-region Active Date',
  craaCrossRegionActiveProvinceCity: 'Cross-region Active Province/City',
  craaReviewAgentId: 'Review Agent ID',
  craaReviewAgentName: 'Review Agent Name',
  craaSubmitter: 'Submitter',
  craaAppealSubmitTime: 'Appeal Submission Time',
  craaReviewTime: 'Review Time',
  craaReviewer: 'Reviewer',
  craaAppealDetailTitle: 'Cross-region Active Device Report Details',
  craaLearningMachineSnCode: 'Learning Machine SN Code',
  craaSituationDescription: 'Situation Description',
  craaPurchaseProof: 'Purchase Proof',
  craaReviewRemark: 'Review Remark',
  craaAppealRecordIdRequired: 'Appeal record ID cannot be empty',
  craaFetchAppealDetailFailed: 'Failed to fetch appeal details',
  craaReportTitle: 'Cross-region Active Device Report',
  craaPleaseEnterSituationDescription: 'Please enter a 5-100 character description',
  craaUploadTip: 'Please upload purchase proof and communication records with parents',
  craaPleaseEnterSituationDescriptionShort: 'Please enter situation description',
  craaSituationDescriptionLengthRule: 'Situation description must be 5 to 100 characters',
  craaPleaseUploadPurchaseProof: 'Please upload purchase proof',
  craaPurchaseProofUploadLimit: 'You can upload up to 9 purchase proof images',
  craaOnlyImageFormatsAllowed: 'Only JPG, JPEG, PNG, and BMP images are allowed',
  craaImageSizeLimit: 'Image size cannot exceed 20MB',
  craaUploadFailed: 'Upload failed',
  craaImageUploadingWait: 'Images are uploading, please submit later',
  craaResubmitSuccess: 'Resubmitted successfully',
  craaResubmitFailed: 'Resubmit failed',
  craaAddReport: '+Add Report',
  craaStatus: 'Status',
  craaPleaseSelectStatus: 'Please select status',
  craaStatusNormal: 'Normal',
  craaStatusObservation: 'Observation',
  craaStatusLocked: 'Locked',
  craaStatusPendingReview: 'Pending Review',
  craaSoftwareActivationDate: 'Software Activation Date',
  craaPleaseSelectSoftwareActivationDateRange: 'Please select software activation date range',
  craaLockDate: 'Lock Date',
  craaPleaseSelectLockDateRange: 'Please select lock date range',
  craaPleaseSelectDateRange: 'Please select date range',
  craaDataSource: 'Data Source',
  craaObservationEndDate: 'Observation End Date',
  craaPleaseSelectCrossCityActiveArea: 'Please select cross-city active area',
  craaGetDealerInfoFailed: 'Failed to get dealer information',
  craaPleaseEnterLearningMachineSnCode: 'Please enter learning machine SN code',
  craaLearningMachineSnCodeLengthRule: 'Learning machine SN code must be within 100 characters',
  craaPleaseSelectCrossRegionActiveProvinceCity: 'Please select cross-region active province/city',
  craaGetProvinceCityDataFailed: 'Failed to get province/city data',
  craaAddReportSuccess: 'Report added successfully',
  craaAddReportFailed: 'Failed to add report',
  bphMarkBackupPhone: 'Mark Backup Phone',
  bphBackupPhoneAvailableQuota: 'Backup Phone Available Quota:',
  bphQuotaHelpTip: 'Backup phone quota is 20% of the dealer\'s active students in the previous month.',
  bphGetQuotaFailed: 'Failed to get backup phone quota',
  bphQueryListFailed: 'Failed to query backup phone list',
  bphNoQuotaNow: 'The current dealer has no backup phone quota.',
  bphDeviceSnCode: 'Device SN Code',
  bphPleaseEnterDeviceSnCode: 'Please enter device SN code',
  bphMarkTime: 'Mark Time',
  bphPleaseSelectMarkTimeRange: 'Please select mark time range',
  bphDeviceModel: 'Device Model',
  bphDealerId: 'Dealer ID',
  bphDealerName: 'Dealer Name',
  bphLocation: 'Location',
  bphDeviceHardwareStatus: 'Device Hardware Status',
  bphHardwareActivationDate: 'Hardware Activation Date',
  bphMarkBackupPhoneDate: 'Backup Phone Mark Date',
  bphDeviceSnCodeWithColon: 'Device SN Code:',
  bphDealerIdWithColon: 'Dealer ID:',
  bphDealerNameWithColon: 'Dealer Name:',
  bphDeviceSnCodeLengthRule: 'Device SN code must be within 100 characters',
  bphDeviceSnChecking: 'Checking device SN...',
  bphDeviceSnCheckPassed: 'Device SN check passed',
  bphDeviceSnCheckFailed: 'Device SN check failed',
  bphPleaseFinishDeviceSnCheckFirst: 'Please complete device SN check first',
  bphConfirmMarkDialogTitle: 'Confirm Mark',
  bphConfirmMarkDialogContent: 'After marking, the current device will revert to software not activated and cannot be activated again. This action cannot be undone. Confirm marking as backup phone?',
  bphMarkBackupPhoneSuccess: 'Backup phone marked successfully',
  bphMarkBackupPhoneFailed: 'Failed to mark backup phone',
  improveCaseStatus: 'Case Status',
  pleaseSelectImproveCaseStatus: 'Select case status',
  /** Marketing — case instance migration (InstanceMigration); scoped keys */
  instanceMigration_belongCampus: 'Affiliated campus',
  instanceMigration_selectBelongCampus: 'Please select affiliated campus',
  instanceMigration_updateTimeColumn: 'Update time',
  instanceMigration_enterCaseNamePlaceholder: 'Please enter case name',
  instanceMigration_selectEnrollmentScore: 'Please select entrance score range',
  instanceMigration_selectProgressScore: 'Please select progress score range',
  instanceMigration_enterStudentAccount: 'Please enter student account',
  studentWithColon: 'Student:',
  pleaseEnterNameOrAccount: 'Enter name or account',
  progressScoreRange5To10: '5 to 10 points',
  progressScoreRangeAbove10: 'Above 10 points',
  progressScoreRangeAbove20: 'Above 20 points',
  progressScoreRangeAbove30: 'Above 30 points',
  progressScoreRangeAbove40: 'Above 40 points',
  enrolScoreRangeBelow40: 'Below 40 points',
  enrolScoreRange41To60: '41 to 60 points',
  enrolScoreRange61To80: '61 to 80 points',
  enrolScoreRangeAbove81: '81 points and above',
  viewStudentHomework: 'View Student Homework',
  practiceReport: 'Practice Report',
  answerRecord: 'Answer Record',
  followContent: 'Follow Content',
  enterFollowContent: 'Enter follow content',
  uploadJpgPngLimit500k: 'Upload jpg/png file, max 500k',
  invitePhysicalExam: 'Invite Physical Exam',
  appointmentTime: 'Appointment Time',
  selectAppointmentDate: 'Select appointment date',
  enterRemark: 'Enter remark',
  openPhysicalExam: 'Open Experience',
  customerName2: 'Customer Name',
  analyst: 'Analyst',
  selectAnalyst: 'Select analyst',
  inviteKnowledgeExam: 'Invite Physical Exam Success',
  inviteKnowledgeExam2: 'Invite Physical Exam',
  inviteKnowledgeExamTime: 'Invite Physical Exam Time',
  account: 'Account',
  password: 'Password',
  homeworkName: 'Homework Name',
  dingtalkUsername: 'DingTalk Username',
  nextFollow: 'Next Follow',
  uploadImageFormat: 'Please upload jpg/png image',
  grade10: 'Grade 10',
  grade11: 'Grade 11',
  grade12: 'Grade 12',
  grade13: 'Retake',
  general170: 'Primary to Junior',
  general175: 'Junior to Senior',
  general180: 'College Entrance Exam',
  export: 'Export',
  textfpck: 'View planning report',
  textybol: 'View report',
  textata5: 'Confirm',
  textctp8: 'OK',
  textew92: 'Cancel',
  textve0v: 'Upload attachment',
  text1eqj: 'Copy and import',
  text3k7c: 'Copy',
  textg7yv: 'Copy link',
  textqtuz: 'Download template',
  textraz2: 'Export all',
  textxb1x: 'Export',
  text0yuv: 'Login type:',
  texti3fa: 'Login mode:',
  textl78x: 'Predictive outbound:',
  textuztd: 'Client phone type:',
  text5gyv: 'Server type:',
  ruleSettingAddTag: 'Add tag',
  ruleSettingAddSource: 'Add source',
  ruleSettingAddExpireReason: 'Add expiry reason',
  activityGalleryPictureNameLabel: 'Picture Name:',
  activityGalleryPictureNamePlaceholder: 'Please enter template name',
  activityGalleryTemplateTypesLabel: 'Template Type:',
  activityGalleryTemplateTypesPlaceholder: 'Please select template type',
  activityGalleryTagLabel: 'Tag:',
  activityGalleryTagTypePlaceholder: 'Tag Type',
  activityGalleryTagIdsPlaceholder: 'Tag',
  activityGalleryAddTemplateButton: 'Add Activity Template',
  activityGalleryDeleteImageButton: 'Delete Image',
  no0: 'No',
  yes1: 'Yes',
  webCall1: 'WebCall',
  webRtc2: 'WebRTC',
  ccs1: 'CCS',
  cti2: 'CTI',
  prototypeMarkWarning:
    'Once a learning device is marked as a prototype, this cannot be changed.',
  }
};
